import { StatusBar } from 'expo-status-bar';
import { useState } from 'react';
import { StyleSheet, Text, View, Dimensions, Alert, Pressable, Linking } from 'react-native';
import { Image, TouchableOpacity, Modal } from 'react-native-web';
import { AntDesign, FontAwesome5, MaterialIcons } from '@expo/vector-icons'; 
import {BrowserView, MobileView} from 'react-device-detect';
import { jsPDF } from "jspdf";
import Firebase, { database } from './firebase-config';
import { ref, get, set } from 'firebase/database';

//Eigene Importe
import { getParticipantInformation, getParticipantName, getParticipantNameForPDF, getParticipantNationality } from './participants';

const backgroundColor = "#444444";
const frontColor = "#626262";
const fontButtonColor = "white";
const lightGreenColor = "#1aaa1a";
const winnerYellowColor = "#ffcc00";
const winnerGoldColorForFullView = "#ccad00";

//MUST CHANGE - to activate
const activated = true;

export default function App() {

  //Diese Variable gibt an, ob die Gesamtansicht aktiv ist
  const [fullView, setFullView] = useState(true);
  const [finished, setFinished] = useState(false);

  //ADS
  const [showBF1Ad, setShowBF1Ad] = useState(false);
  const [showBF2Ad, setShowBF2Ad] = useState(false);
  const [showCO1Ad, setShowCO1Ad] = useState(false);
  const [showBF1AdEN, setShowBF1AdEN] = useState(false);
  const [showBF2AdEN, setShowBF2AdEN] = useState(false);
  const [showCO1AdEN, setShowCO1AdEN] = useState(false);

  //Tipps für die einzelnen Runden
  const [L128, setL128] = useState(getPlayersToPlan());
  const [L64, setL64] = useState([1,0,32,0,16,0,17,0,8,0,25,0,9,0,24,0,4,0,29,0,13,0,20,0,5,0,28,0,12,0,21,0,2,0,31,0,15,0,18,0,7,0,26,0,10,0,23,0,3,0,30,0,14,0,19,0,6,0,27,0,11,0,22,0]);
  const [L32, setL32] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);
  const [L16, setL16] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);
  const [L8, setL8] = useState([0,0,0,0,0,0,0,0]);
  const [L4, setL4] = useState([0,0,0,0]);
  const [L2, setL2] = useState([0,0]);
  const [L1, setL1] = useState([0]);

  const seated32 = [1,32,16,17,8,25,9,24,4,29,13,20,5,28,12,21,2,31,15,18,7,26,10,23,3,30,14,19,6,27,11,22];
  const [fullL128, setFullL128] = useState(getFullL128());

  //Dies sind die 8 zu tippenden Spieler
  const [currentPreditcionOne, setCurrentPredictionOne] = useState(0);
  const [currentPreditcionTwo, setCurrentPredictionTwo] = useState(0);
  const [currentPreditcionThree, setCurrentPredictionThree] = useState(0);
  const [currentPreditcionFour, setCurrentPredictionFour] = useState(0);
  const [currentPreditcionFive, setCurrentPredictionFive] = useState(0);
  const [currentPreditcionSix, setCurrentPredictionSix] = useState(0);
  const [currentPreditcionSeven, setCurrentPredictionSeven] = useState(0);
  const [currentPreditcionEight, setCurrentPredictionEight] = useState(0);

  //Dies sind die 4 Spieler die getippt wurden
  const [currentFinalPredictionOne, setCurrentFinalPredictionOne] = useState(0);
  const [currentFinalPredictionTwo, setCurrentFinalPredictionTwo] = useState(0);
  const [currentFinalPredictionThree, setCurrentFinalPredictionThree] = useState(0);
  const [currentFinalPredictionFour, setCurrentFinalPredictionFour] = useState(0);

  const [currentRound, setCurrentRound] = useState(128);
  const [roundStatus, setRoundStatus] = useState(0);

  const [showCurrentInformationModal, setShowCurrentInformationModal] = useState(false);
  const [currentInformationName, setCurrentInformationName] = useState("");
  const [currentInformationInformation, setCurrentInformationInformation] = useState("");
  const [currentInformationCountry, setCurrentInformationCountry] = useState("");


  //Important to modify !!!
  function getPlayersToPlan()
  {
    let firstRoundMatches = [];

      //Match vs. (1) Luke Humphries
      firstRoundMatches[0] = 52;
      firstRoundMatches[1] = 69;

      //Match vs. (32) Raymond van Barneveld
      firstRoundMatches[2] = 61;
      firstRoundMatches[3] = 72;

      //Match vs. (16) James Wade
      firstRoundMatches[4] = 35;
      firstRoundMatches[5] = 91;

      //Match vs. (17) Peter Wright
      firstRoundMatches[6] = 43;
      firstRoundMatches[7] = 76;

      //Match vs. (8) Stephen Bunting
      firstRoundMatches[8] = 40;
      firstRoundMatches[9] = 90;

      //Match vs. (25) Dirk van Duijvenbode
      firstRoundMatches[10] = 41;
      firstRoundMatches[11] = 88;

      //Match vs. (9) Damon Heta
      firstRoundMatches[12] = 53;
      firstRoundMatches[13] = 78;

      //Match vs. (24) Mike De Decker
      firstRoundMatches[14] = 37;
      firstRoundMatches[15] = 77;

      //Match vs. (4) Luke Littler
      firstRoundMatches[16] = 59;
      firstRoundMatches[17] = 83;

      //Match vs. (29) Ritchie Edhouse
      firstRoundMatches[18] = 55;
      firstRoundMatches[19] = 85;

      //Match vs. (13) Danny Noppert
      firstRoundMatches[20] = 38;
      firstRoundMatches[21] = 67;

      //Match vs. (20) Ryan Searle
      firstRoundMatches[22] = 54;
      firstRoundMatches[23] = 96;

      //Match vs. (5) Rob Cross
      firstRoundMatches[24] = 47;
      firstRoundMatches[25] = 80;

      //Match vs. (28) Gian van Veen
      firstRoundMatches[26] = 36;
      firstRoundMatches[27] = 65;

      //Match vs. (12) Nathan Aspinall
      firstRoundMatches[28] = 33;
      firstRoundMatches[29] = 70;

      //Match vs. (21) Andrew Gilding
      firstRoundMatches[30] = 44;
      firstRoundMatches[31] = 87;

      //Match vs. (2) Michael Smith
      firstRoundMatches[32] = 45;
      firstRoundMatches[33] = 82;

      //Match vs. (31) Krzysztof Ratajski
      firstRoundMatches[34] = 46;
      firstRoundMatches[35] = 74;

      //Match vs. (15) Chris Dobey
      firstRoundMatches[36] = 51;
      firstRoundMatches[37] = 89;

      //Match vs. (18) Josh Rock
      firstRoundMatches[38] = 50;
      firstRoundMatches[39] = 93;

      //Match vs. (7) Janny Clayton
      firstRoundMatches[40] = 63;
      firstRoundMatches[41] = 68;

      //Match vs. (26) Daryl Gurney
      firstRoundMatches[42] = 58;
      firstRoundMatches[43] = 94;

      //Match vs. (10) Gerwyn Price
      firstRoundMatches[44] = 48;
      firstRoundMatches[45] = 81;

      //Match vs. (23) Joe Cullen
      firstRoundMatches[46] = 34;
      firstRoundMatches[47] = 73;
            
      //Match vs. (3) Michael van Gerwen
      firstRoundMatches[48] = 62;
      firstRoundMatches[49] = 71;

      //Match vs. (30) Brendan Dolan
      firstRoundMatches[50] = 60;
      firstRoundMatches[51] = 86;

      //Match vs. (14) Gary Anderson
      firstRoundMatches[52] = 56;
      firstRoundMatches[53] = 79;

      //Match vs. (19) Ross Smith
      firstRoundMatches[54] = 57;
      firstRoundMatches[55] = 75;

      //Match vs. (6) Dave Chisnall
      firstRoundMatches[56] = 64;
      firstRoundMatches[57] = 84;

      //Match vs. (27) Gabriel Clemens
      firstRoundMatches[58] = 39;
      firstRoundMatches[59] = 66;

      //Match vs. (11) Dimitri Van den Bergh
      firstRoundMatches[60] = 49;
      firstRoundMatches[61] = 95;

      //Match vs. (22) Martin Schindler
      firstRoundMatches[62] = 42;
      firstRoundMatches[63] = 92;

    return firstRoundMatches;
  }

  function startPrediction()
  {
    getNextPlayersInL128Section(0);
    setFullView(false);

    logAnalytics_STARTED();
  }

  function goNext()
  {
    if(currentRound == 2)
    {
      finishSimulation();
      return;
    }

    clearPlayerInformation();

    if(currentRound == 128)
    {
      //ADS
      if(roundStatus === 1)
      {
        displayAd(1);
      }
      
      updatePlayersInL64(roundStatus, currentFinalPredictionOne, currentFinalPredictionTwo, currentFinalPredictionThree, currentFinalPredictionFour);
    }
    else if(currentRound == 64)
    {
      updatePlayersInL32(roundStatus, currentFinalPredictionOne, currentFinalPredictionTwo, currentFinalPredictionThree, currentFinalPredictionFour);
    }
    else if(currentRound == 32)
    {
      //ADS
      if(roundStatus === 1)
      {
        displayAd(2);
      }
      updatePlayersInL16(roundStatus, currentFinalPredictionOne, currentFinalPredictionTwo, currentFinalPredictionThree, currentFinalPredictionFour);
    }
    else if(currentRound == 16)
    {
      updatePlayersInL8(roundStatus, currentFinalPredictionOne, currentFinalPredictionTwo, currentFinalPredictionThree, currentFinalPredictionFour);
    }
    else if(currentRound == 8)
    {
      updatePlayersInL4(roundStatus, currentFinalPredictionOne, currentFinalPredictionTwo, currentFinalPredictionThree, currentFinalPredictionFour);
    }
    else if(currentRound == 4)
    {
      displayAd(3);
      updatePlayersInL2(roundStatus, currentFinalPredictionOne, currentFinalPredictionTwo);
    }
    else if(currentRound == 2)
    {
      updatePlayersInL1(roundStatus, currentFinalPredictionOne);
    }
    
    clearPredictedFinalPlayers();

    if(currentRound == 128)
    {
      getNextPlayersInL128Section(roundStatus+1);
    }
    else if(currentRound == 64)
    {
      getNextPlayersInL64Section(roundStatus+1);
    }
    else if(currentRound == 32)
    {
      getNextPlayersInL32Section(roundStatus+1);
    }
    else if(currentRound == 16)
    {
      getNextPlayersInL16Section(roundStatus+1);
    }
    else if(currentRound == 8)
    {
      getNextPlayersInL8Section(roundStatus+1);
    }
    else if(currentRound == 4)
    {
      getNextPlayersInL4Section(roundStatus+1);
    }
    else if(currentRound == 2)
    {
      getNextPlayersInL2Section(roundStatus+1);
    }

    setRoundStatus(roundStatus+1);

    if((roundStatus + 1) >= currentRound / 8)
    {
      increaseRoundInTournament(currentRound / 2);
      return;
    }
  }

  function goBack()
  {

    if(currentRound == 128)
    {
      updatePlayersInL64(roundStatus, currentFinalPredictionOne, currentFinalPredictionTwo, currentFinalPredictionThree, currentFinalPredictionFour);
    }
    else if(currentRound == 64)
    {
      updatePlayersInL32(roundStatus, currentFinalPredictionOne, currentFinalPredictionTwo, currentFinalPredictionThree, currentFinalPredictionFour);
    }
    else if(currentRound == 32)
    {
      updatePlayersInL16(roundStatus, currentFinalPredictionOne, currentFinalPredictionTwo, currentFinalPredictionThree, currentFinalPredictionFour);
    }
    else if(currentRound == 16)
    {
      updatePlayersInL8(roundStatus, currentFinalPredictionOne, currentFinalPredictionTwo, currentFinalPredictionThree, currentFinalPredictionFour);
    }
    else if(currentRound == 8)
    {
      updatePlayersInL4(roundStatus, currentFinalPredictionOne, currentFinalPredictionTwo, currentFinalPredictionThree, currentFinalPredictionFour);
    }
    else if(currentRound == 4)
    {
      updatePlayersInL2(roundStatus, currentFinalPredictionOne, currentFinalPredictionTwo);
    }
    else if(currentRound == 2)
    {
      updatePlayersInL1(roundStatus, currentFinalPredictionOne);
    }

    clearPlayerInformation();
    clearPredictedFinalPlayers();

    if(currentRound == 128)
    {
      getNextPlayersInL128Section(roundStatus-1);
    }
    else if(currentRound == 64)
    {
      getNextPlayersInL64Section(roundStatus-1);
    }
    else if(currentRound == 32)
    {
      getNextPlayersInL32Section(roundStatus-1);
    }
    else if(currentRound == 16)
    {
      getNextPlayersInL16Section(roundStatus-1);
    }
    else if(currentRound == 8)
    {
      getNextPlayersInL8Section(roundStatus-1);
    }
    else if(currentRound == 4)
    {
      getNextPlayersInL4Section(roundStatus-1);
    }
    else if(currentRound == 2)
    {
      getNextPlayersInL2Section(roundStatus-1);
    }


    setRoundStatus(roundStatus-1);

    if((roundStatus + 1) <= 1)
    {
      decreaseRoundInTournament(currentRound*2);
      return;
    }
  }

  function finishSimulation()
  {
    updatePlayersInL1(roundStatus, currentFinalPredictionOne);
    
    setFinished(true);
    setFullView(true);

    logAnalytics_WINNER(getParticipantName(L1));
  }

  function increaseRoundInTournament(newRound)
  {
    setCurrentRound(newRound);
    clearPlayerInformation();
    clearPredictedFinalPlayers();
    setRoundStatus(0);

    if(newRound == 64)
    {
      getNextPlayersInL64Section(0);
    }
    else if(newRound == 32)
    {
      getNextPlayersInL32Section(0);
    }
    else if(newRound == 16)
    {
      getNextPlayersInL16Section(0);
    }
    else if(newRound == 8)
    {
      getNextPlayersInL8Section(0);
    }
    else if(newRound == 4)
    {
      getNextPlayersInL4Section(0);
    }
    else if(newRound == 2)
    {
      getNextPlayersInL2Section(0);
    }
  }

  function decreaseRoundInTournament(newRound)
  {
    if(newRound == 256)
    {
      return;
    }
    setCurrentRound(newRound);
    clearPlayerInformation();
    clearPredictedFinalPlayers();

    if(newRound == 128)
    {
      setRoundStatus(15);
      getNextPlayersInL128Section(15);
    }
    else if(newRound == 64)
    {
      setRoundStatus(7);
      getNextPlayersInL64Section(7);
    }
    else if(newRound == 32)
    {
      setRoundStatus(3);
      getNextPlayersInL32Section(3);
    }
    else if(newRound == 16)
    {
      setRoundStatus(1);
      getNextPlayersInL16Section(1);
    }
    else if(newRound == 8)
    {
      setRoundStatus(0);
      getNextPlayersInL8Section(0);
    }
    else if(newRound == 4)
    {
      setRoundStatus(0);
      getNextPlayersInL4Section(0);
    }
    else if(newRound == 2)
    {
      setRoundStatus(0);
      getNextPlayersInL2Section(0);
    }
  }

  function showParticipantInformation(id)
  {
    setCurrentInformationName(getParticipantName(id));
    setCurrentInformationInformation(getParticipantInformation(id));
    setCurrentInformationCountry(getParticipantNationality(id));

    setShowCurrentInformationModal(true);
  }

  function showParticipantInformationMobile(id)
  {
    setCurrentInformationName(getParticipantName(id));
    setCurrentInformationInformation(getParticipantInformation(id));
    setCurrentInformationCountry(getParticipantNationality(id));

    setShowCurrentInformationModal(true);
  }

  function handleParticipantBet(id, newArrayID)
  {
    if (newArrayID == 0)
    {
      setCurrentFinalPredictionOne(id);
    }
    else if(newArrayID == 1)
    {
      setCurrentFinalPredictionTwo(id);
    }
    else if(newArrayID == 2)
    {
      setCurrentFinalPredictionThree(id);
    }
    else
    {
      setCurrentFinalPredictionFour(id);
    }
    clearPlayerInformation();
  }

  function clearPlayerInformation()
  {
    setCurrentInformationName(getParticipantName(0));
    setCurrentInformationInformation(getParticipantInformation(0));
    setCurrentInformationCountry(getParticipantNationality(0));
  }

  function getNextPlayersInL128Section(status)
  {
    setCurrentPredictionOne(fullL128[8*status+0]);
    setCurrentPredictionTwo(fullL128[8*status+1]);
    setCurrentPredictionThree(fullL128[8*status+2]);
    setCurrentPredictionFour(fullL128[8*status+3]);
    setCurrentPredictionFive(fullL128[8*status+4]);
    setCurrentPredictionSix(fullL128[8*status+5]);
    setCurrentPredictionSeven(fullL128[8*status+6]);
    setCurrentPredictionEight(fullL128[8*status+7]);

    setCurrentFinalPredictionOne(L64[4*status+0]);
    setCurrentFinalPredictionTwo(L64[4*status+1]);
    setCurrentFinalPredictionThree(L64[4*status+2]);
    setCurrentFinalPredictionFour(L64[4*status+3]);
  }

  function getNextPlayersInL64Section(status)
  {
    setCurrentPredictionOne(L64[8*status+0]);
    setCurrentPredictionTwo(L64[8*status+1]);
    setCurrentPredictionThree(L64[8*status+2]);
    setCurrentPredictionFour(L64[8*status+3]);
    setCurrentPredictionFive(L64[8*status+4]);
    setCurrentPredictionSix(L64[8*status+5]);
    setCurrentPredictionSeven(L64[8*status+6]);
    setCurrentPredictionEight(L64[8*status+7]);
    
    setCurrentFinalPredictionOne(L32[4*status+0]);
    setCurrentFinalPredictionTwo(L32[4*status+1]);
    setCurrentFinalPredictionThree(L32[4*status+2]);
    setCurrentFinalPredictionFour(L32[4*status+3]);
  }

  function getNextPlayersInL32Section(status)
  {
    setCurrentPredictionOne(L32[8*status+0]);
    setCurrentPredictionTwo(L32[8*status+1]);
    setCurrentPredictionThree(L32[8*status+2]);
    setCurrentPredictionFour(L32[8*status+3]);
    setCurrentPredictionFive(L32[8*status+4]);
    setCurrentPredictionSix(L32[8*status+5]);
    setCurrentPredictionSeven(L32[8*status+6]);
    setCurrentPredictionEight(L32[8*status+7]);
    
    setCurrentFinalPredictionOne(L16[4*status+0]);
    setCurrentFinalPredictionTwo(L16[4*status+1]);
    setCurrentFinalPredictionThree(L16[4*status+2]);
    setCurrentFinalPredictionFour(L16[4*status+3]);
  }

  function getNextPlayersInL16Section(status)
  {
    setCurrentPredictionOne(L16[8*status+0]);
    setCurrentPredictionTwo(L16[8*status+1]);
    setCurrentPredictionThree(L16[8*status+2]);
    setCurrentPredictionFour(L16[8*status+3]);
    setCurrentPredictionFive(L16[8*status+4]);
    setCurrentPredictionSix(L16[8*status+5]);
    setCurrentPredictionSeven(L16[8*status+6]);
    setCurrentPredictionEight(L16[8*status+7]);
    
    setCurrentFinalPredictionOne(L8[4*status+0]);
    setCurrentFinalPredictionTwo(L8[4*status+1]);
    setCurrentFinalPredictionThree(L8[4*status+2]);
    setCurrentFinalPredictionFour(L8[4*status+3]);
  }

  function getNextPlayersInL8Section(status)
  {
    setCurrentPredictionOne(L8[8*status+0]);
    setCurrentPredictionTwo(L8[8*status+1]);
    setCurrentPredictionThree(L8[8*status+2]);
    setCurrentPredictionFour(L8[8*status+3]);
    setCurrentPredictionFive(L8[8*status+4]);
    setCurrentPredictionSix(L8[8*status+5]);
    setCurrentPredictionSeven(L8[8*status+6]);
    setCurrentPredictionEight(L8[8*status+7]);
    
    setCurrentFinalPredictionOne(L4[0]);
    setCurrentFinalPredictionTwo(L4[1]);
    setCurrentFinalPredictionThree(L4[2]);
    setCurrentFinalPredictionFour(L4[3]);
  }

  function getNextPlayersInL4Section(status)
  {
    setCurrentPredictionOne(L4[8*status+0]);
    setCurrentPredictionTwo(L4[8*status+1]);
    setCurrentPredictionThree(L4[8*status+2]);
    setCurrentPredictionFour(L4[8*status+3]);
    
    setCurrentFinalPredictionOne(L2[0]);
    setCurrentFinalPredictionTwo(L2[1]);
  }

  function getNextPlayersInL2Section(status)
  {
    setCurrentPredictionOne(L2[8*status+0]);
    setCurrentPredictionTwo(L2[8*status+1]);
    
    setCurrentFinalPredictionOne(L1[0]);
  }

  function clearPredictedFinalPlayers()
  {
    setCurrentFinalPredictionOne(0);
    setCurrentFinalPredictionTwo(0);
    setCurrentFinalPredictionThree(0);
    setCurrentFinalPredictionFour(0);
  }

  function getFullL128()
  {
    let tempL128 = [];

    for (let index = 0; index <128; index++) {
      if(index % 4 == 0)
      {
        tempL128[index] = seated32[index / 4];
      }
      else if(index % 4 == 1)
      {
        tempL128[index] = 0;
      }
      else if(index % 4 == 2)
      {
        tempL128[index] = L128[(index - 2) / 2];
        tempL128[index+1] = L128[((index - 2) / 2)+1];
      }
      else if(index % 4 == 3)
      {
        
      }
    }

    return tempL128;
  }

  function updatePlayersInL64(status, idPlayer1, idPLayer2, idPlayer3, idPlayer4)
  {
    let tempL64 = L64;

    tempL64[4*status+0] = idPlayer1;
    tempL64[4*status+1] = idPLayer2;
    tempL64[4*status+2] = idPlayer3;
    tempL64[4*status+3] = idPlayer4;

    setL64(tempL64);
  }

  function updatePlayersInL32(status, idPlayer1, idPLayer2, idPlayer3, idPlayer4)
  {
    let tempL32 = L32;

    tempL32[4*status+0] = idPlayer1;
    tempL32[4*status+1] = idPLayer2;
    tempL32[4*status+2] = idPlayer3;
    tempL32[4*status+3] = idPlayer4;

    setL32(tempL32);
  }

  function updatePlayersInL16(status, idPlayer1, idPLayer2, idPlayer3, idPlayer4)
  {
    let tempL16 = L16;

    tempL16[4*status+0] = idPlayer1;
    tempL16[4*status+1] = idPLayer2;
    tempL16[4*status+2] = idPlayer3;
    tempL16[4*status+3] = idPlayer4;

    setL16(tempL16);
  }

  function updatePlayersInL8(status, idPlayer1, idPLayer2, idPlayer3, idPlayer4)
  {
    let tempL8 = L8;

    tempL8[4*status+0] = idPlayer1;
    tempL8[4*status+1] = idPLayer2;
    tempL8[4*status+2] = idPlayer3;
    tempL8[4*status+3] = idPlayer4;

    setL8(tempL8);
  }

  function updatePlayersInL4(status, idPlayer1, idPLayer2, idPlayer3, idPlayer4)
  {
    let tempL4 = L4;

    tempL4[4*status+0] = idPlayer1;
    tempL4[4*status+1] = idPLayer2;
    tempL4[4*status+2] = idPlayer3;
    tempL4[4*status+3] = idPlayer4;

    setL4(tempL4);
  }

  function updatePlayersInL2(status, idPlayer1, idPLayer2)
  {
    let tempL2 = L2;

    tempL2[4*status+0] = idPlayer1;
    tempL2[4*status+1] = idPLayer2;

    setL2(tempL2);
  }

  function updatePlayersInL1(status, idPlayer1)
  {
    let tempL1 = L1;

    tempL1[4*status+0] = idPlayer1;

    setL1(tempL1);
  }

  function getUsableHeight(scenery)
  {
    const height = Dimensions.get('screen').height;
    const heightGrenze = 1081;

    //Question mark Icon
    if(scenery == "qmark")
    {
      //Großer Screen
      if(height >= heightGrenze)
      {
        return 24;
      }
      //Kleiner Screen
      else
      {
        return 16;
      }
    }
    //Arrow right icon
    else if(scenery == "arrow")
    {
      //Großer Screen
      if(height >= heightGrenze)
      {
        return 36;
      }
      //Kleiner Screen
      else
      {
        return 16;
      }
    }
    //headlineText
    else if(scenery == "hlText")
    {
      //Großer Screen
      if(height >= heightGrenze)
      {
        return 22;
      }
      //Kleiner Screen
      else
      {
        return 20;
      }
    }
    //playerText
    else if(scenery == "pText")
    {
      //Großer Screen
      if(height >= heightGrenze)
      {
        return 12;
      }
      //Kleiner Screen
      else
      {
        return 12;
      }
    }
    //predictionPlayerText
    else if(scenery == "ppText")
    {
      //Großer Screen
      if(height >= heightGrenze)
      {
        return 28;
      }
      //Kleiner Screen
      else
      {
        return 20;
      }
    }
    //playerInformationText
    else if(scenery == "piText")
    {
      //Großer Screen
      if(height >= heightGrenze)
      {
        return 18;
      }
      //Kleiner Screen
      else
      {
        return 14;
      }
    }
    //is Screen small screen ?
    else if(scenery == "smallScreen")
    {
      //Großer Screen
      if(height >= heightGrenze)
      {
        return false;
      }
      //Kleiner Screen
      else
      {
        return true;
      }
    }
  }

  function createNewPDF()
  {
    var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape", format: "a1"});
    var imgData = "data:image/png;base64,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";

      doc.setFillColor(backgroundColor);
      doc.rect(0, 0, 1000, 1000, 'FD');

      doc.setTextColor("white");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(55);
      doc.text("PDC World Championship 2025 Simulation", 10, 28);
      doc.addImage(imgData, 'JPEG', 510, 294, 150, 57);

      //L128 Matches
        doc.setFont("helvetica", "bold");
        doc.setTextColor("white");
        doc.setFontSize(25);
        doc.text("Round 1 / L128", 10, 50);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(16);

        var currentHeightL128 = 0;
        for (let index = 0; index < L128.length; index++) {

          if(L64.includes(L128[index]))
          {
            doc.setFont("helvetica", "bold");

            if(L1.includes(L128[index]))
            {
              doc.setTextColor(winnerYellowColor);
            }
            else
            {
              doc.setTextColor("white");
            }

          }
          else
          {
            doc.setFont("helvetica", "normal");
            doc.setTextColor("white");
          }

          if(index % 2 == 0)
          {
            doc.setDrawColor(frontColor)
            doc.setFillColor(frontColor);
            doc.roundedRect(8, (64 + currentHeightL128), 80, 14, 1, 1,'FD');

            doc.line(88, (71 + currentHeightL128), 130, (71 + currentHeightL128));
          }

          doc.text(getParticipantNameForPDF(L128[index]), 10, (70 + currentHeightL128));
          currentHeightL128 += (index % 2 == 1) ? 10 : 6;
        }


      //L64 Matches
        doc.setFont("helvetica", "bold");
        doc.setTextColor("white");
        doc.setFontSize(25);
        doc.text("Round 2 / L64", 130, 50);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(16);

        var currentHeightL64 = 0;
        for (let index = 0; index < L64.length; index++) {

          if(L32.includes(L64[index]))
          {
            doc.setFont("helvetica", "bold");

            if(L1.includes(L64[index]))
            {
              doc.setTextColor(winnerYellowColor);
            }
            else
            {
              doc.setTextColor("white");
            }

          }
          else
          {
            doc.setFont("helvetica", "normal");
            doc.setTextColor("white");
          }

          if(index % 2 == 0)
          {
            doc.setFillColor(frontColor);
            doc.roundedRect(128, (64 + currentHeightL64), 80, 14, 1, 1, 'FD');

            doc.line(208, (72 + currentHeightL64), 229, (72 + currentHeightL64));
          }

          doc.text(getParticipantNameForPDF(L64[index]), 130, (70 + currentHeightL64));
          currentHeightL64 += (index % 2 == 1) ? 10 : 6;
        }



      //L32 Matches
        doc.setFont("helvetica", "bold");
        doc.setTextColor("white");
        doc.setFontSize(25);
        doc.text("Round 3 / L32", 250, 50);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(16);

        var currentHeightL32 = 0;
        for (let index = 0; index < L32.length; index++) {

          if(L16.includes(L32[index]))
          {
            doc.setFont("helvetica", "bold");

            if(L1.includes(L32[index]))
            {
              doc.setTextColor(winnerYellowColor);
            }
            else
            {
              doc.setTextColor("white");
            }

          }
          else
          {
            doc.setFont("helvetica", "normal");
            doc.setTextColor("white");
          }

          if(index % 2 == 0)
          {
            doc.setFillColor(frontColor);
            doc.roundedRect(248, (74 + currentHeightL32), 80, 14, 1, 1, 'FD');

            doc.line(229, (81 + currentHeightL32), 250, (81 + currentHeightL32));
            doc.line(229, (72 + currentHeightL32), 229, (88 + currentHeightL32));

            doc.line(318, (81 + currentHeightL32), 346, (81 + currentHeightL32));
          }

          doc.text(getParticipantNameForPDF(L32[index]), 250, (80 + currentHeightL32));
          currentHeightL32 += (index % 2 == 1) ? 26 : 6;
        }


    //L16 Matches
      doc.setFont("helvetica", "bold");
      doc.setTextColor("white");
      doc.setFontSize(25);
      doc.text("Round 4 / L16", 370, 50);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(16);

      var currentHeightL16 = 0;
      for (let index = 0; index < L16.length; index++) {

        if(L8.includes(L16[index]))
        {
          doc.setFont("helvetica", "bold");

          if(L1.includes(L16[index]))
          {
            doc.setTextColor(winnerYellowColor);
          }
          else
          {
            doc.setTextColor("white");
          }

        }
        else
        {
          doc.setFont("helvetica", "normal");
          doc.setTextColor("white");
        }

        if(index % 2 == 0)
        {
          doc.setFillColor(frontColor);
          doc.roundedRect(368, (90 + currentHeightL16), 80, 14, 1, 1, 'FD');

          doc.line(346, (97 + currentHeightL16), 370, (97 + currentHeightL16));
          doc.line(346, (81 + currentHeightL16), 346, (113 + currentHeightL16));

          doc.line(448, (97 + currentHeightL16), 469, (97 + currentHeightL16));
        }

        doc.text(getParticipantNameForPDF(L16[index]), 370, (96 + currentHeightL16));
        currentHeightL16 += (index % 2 == 1) ? 58 : 6;
      }

  //L8 Matches
    doc.setFont("helvetica", "bold");
    doc.setTextColor("white");
    doc.setFontSize(25);
    doc.text("Quarterfinal / L8", 490, 50);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(16);

    var currentHeightL8 = 0;
    for (let index = 0; index < L8.length; index++) {

      if(L4.includes(L8[index]))
      {
        doc.setFont("helvetica", "bold");

        if(L1.includes(L8[index]))
        {
          doc.setTextColor(winnerYellowColor);
        }
        else
        {
          doc.setTextColor("white");
        }

      }
      else
      {
        doc.setFont("helvetica", "normal");
        doc.setTextColor("white");
      }

      if(index % 2 == 0)
      {
        doc.setFillColor(frontColor);
        doc.roundedRect(488, (119 + currentHeightL8), 80, 14, 1, 1, 'FD');

        doc.line(469, (126 + currentHeightL8), 490, (126 + currentHeightL8));
        doc.line(469, (97 + (currentHeightL8-(currentHeightL8/65))), 469, (161 + (currentHeightL8-(currentHeightL8/65))));

        doc.line(568, (126 + currentHeightL8), 589, (126 + currentHeightL8));
      }

      doc.text(getParticipantNameForPDF(L8[index]), 490, (125 + currentHeightL8));
      currentHeightL8 += (index % 2 == 1) ? 124 : 6;
    }


  //L4 Matches
    doc.setFont("helvetica", "bold");
    doc.setTextColor("white");
    doc.setFontSize(25);
    doc.text("Semifinal / L4", 610, 50);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(16);

    var currentHeightL4 = 0;
    for (let index = 0; index < L4.length; index++) {

      if(L2.includes(L4[index]))
      {
        doc.setFont("helvetica", "bold");

        if(L1.includes(L4[index]))
        {
          doc.setTextColor(winnerYellowColor);
        }
        else
        {
          doc.setTextColor("white");
        }

      }
      else
      {
        doc.setFont("helvetica", "normal");
        doc.setTextColor("white");
      }

      if(index % 2 == 0)
      {
        doc.setFillColor(frontColor);
        doc.roundedRect(606, (181 + currentHeightL4), 80, 14, 1, 1, 'FD');

        doc.line(589, (188 + currentHeightL4), 610, (188 + currentHeightL4));
        doc.line(589, (126 + (currentHeightL4-(currentHeightL4/45))), 589, (256 + (currentHeightL4-(currentHeightL4/45))));

        doc.line(686, (188 + currentHeightL4), 708, (188 + currentHeightL4));
      }

      doc.text(getParticipantNameForPDF(L4[index]), 610, (187 + currentHeightL4));
      currentHeightL4 += (index % 2 == 1) ? 260 : 6;
    }

  
  //L2 Matches
    doc.setFont("helvetica", "bold");
    doc.setTextColor("white");
    doc.setFontSize(25);
    doc.text("Final", 730, 50);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(16);

    var currentHeightL2 = 0;
    for (let index = 0; index < L2.length; index++) {

      if(L1.includes(L2[index]))
      {
        doc.setFont("helvetica", "bold");
        doc.setTextColor(winnerYellowColor);
      }
      else
      {
        doc.setFont("helvetica", "normal");
        doc.setTextColor("white");
      }

      if(index % 2 == 0)
      {
        doc.setFillColor(frontColor);
        doc.roundedRect(728, (311 + currentHeightL2), 80, 14, 1, 1, 'FD');

        doc.line(708, (318 + currentHeightL2), 730, (318 + currentHeightL2));
        doc.line(708, (188 + currentHeightL2), 708, (454 + currentHeightL2));
      }

      doc.text(getParticipantNameForPDF(L2[index]), 730, (317 + currentHeightL2));
      currentHeightL2 += (index % 2 == 1) ? 260 : 6;
    }
  
    var currentdate = new Date(); 
    var datetime = currentdate.getDate() + "."
                + (currentdate.getMonth()+1)  + "." 
                + currentdate.getFullYear() + " "  
                + currentdate.getHours() + ":"  
                + currentdate.getMinutes() + ":" 
                + currentdate.getSeconds();

    doc.setTextColor("white");
    doc.text(datetime, 770, 580);

    doc.save("PDC World Championship 2025 Simulation by MyDartCoach.pdf");
  }

  const logAnalytics_ADS = async (isDE, adNum) => {

    const ad1DE = 'wc2025-simulation/ad1DE/';
    const ad2DE = 'wc2025-simulation/ad2DE/';
    const ad3DE = 'wc2025-simulation/ad3DE/';
    const ad1EN = 'wc2025-simulation/ad1EN/';
    const ad2EN = 'wc2025-simulation/ad2EN/';
    const ad3EN = 'wc2025-simulation/ad3EN/';

    let path = isDE === true ? (adNum === 1 ? ad1DE : (adNum === 2 ? ad2DE : ad3DE)) : (adNum === 1 ? ad1EN : (adNum === 2 ? ad2EN : ad3EN));

    const analyticsRef = ref(database, path);
  
    try {
      const snapshot = await get(analyticsRef);
      const currentValue = snapshot.val() || 0;
  
      // Aktualisiere den Wert um 1
      await set(analyticsRef, currentValue + 1);
  
      console.log('Analytics erfolgreich geloggt.');
    } catch (error) {
      console.error('Fehler beim Loggen der Analytics:', error.message);
    }
  };

  const logAnalytics_STARTED = async () => {
    const analyticsRef = ref(database, 'wc2025-simulation/predictionsCount/');
  
    try {
      const snapshot = await get(analyticsRef);
      const currentValue = snapshot.val() || 0;
  
      // Aktualisiere den Wert um 1
      await set(analyticsRef, currentValue + 1);
  
      console.log('Analytics erfolgreich geloggt.');
    } catch (error) {
      console.error('Fehler beim Loggen der Analytics:', error.message);
    }
  };

  const logAnalytics_WINNER = async (winner) => {
    const winnersRef = ref(database, 'wc2025-simulation/predictedWinners/');
  
    try {
      const snapshot = await get(winnersRef);
      const winners = snapshot.val() || {};
  
      // Überprüfe, ob der Gewinner bereits existiert
      if (winners[winner]) {
        // Wenn der Gewinner existiert, inkrementiere die Anzahl
        winners[winner] += 1;
      } else {
        // Wenn der Gewinner nicht existiert, setze die Anzahl auf 1
        winners[winner] = 1;
      }
  
      // Aktualisiere die Daten in der Datenbank
      await set(winnersRef, winners);
  
      console.log(`Gewinner ${winner} erfolgreich geloggt.`);
    } catch (error) {
      console.error('Fehler beim Loggen des Gewinners:', error.message);
    }
  };

  function displayAd(num)
  {
    const userLanguage = navigator.language || navigator.userLanguage;

    if (userLanguage.startsWith('de')) {
        
        if(num === 1)
        {
          setShowBF1Ad(true);
          logAnalytics_ADS(true, 1);
        }
        else if(num === 2)
        {
          setShowCO1Ad(true);
          logAnalytics_ADS(true, 2);
        }
        else if(num === 3)
        {
          setShowBF2Ad(true);
          logAnalytics_ADS(true, 3);
        }

    } else {
      
      if(num === 1)
        {
          setShowBF1AdEN(true);
          logAnalytics_ADS(false, 1);
        }
        else if(num === 2)
        {
          setShowCO1AdEN(true);
          logAnalytics_ADS(false, 2);
        }
        else if(num === 3)
        {
          setShowBF2AdEN(true);
          logAnalytics_ADS(false, 3);
        }

    }

  }


  return (
    <View style={styles.container}>

      <BrowserView style={styles.content}>

          {
            fullView == true ?

              activated === false ?

              <View style={{width: '100%', height: '100%', padding: '0.5%', justifyContent: 'center', alignItems: 'center'}}>

                <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText"), textAlign: 'center'}}>{"The Darts World Championship 2025 Simulation of MyDartCoach is not yet online.\nThe simulation is planned to be available here on this website 15 minutes after the end of the draw."}</Text>

              </View>

              :

              <View style={{width: '100%', height: '100%', padding: '0.5%', justifyContent: 'center', alignItems: 'center'}}>

                <View style={{width: '100%', height: '2.5%', flexDirection: 'row'}}>

                  {/* L128 Headline */}
                  <View style={styles.columnPlayers}>
                    <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Round 1 / L128</Text>
                  </View>

                  <View style={styles.columnLine}>
                  </View>

                  {/* L64 Headline */}
                  <View style={styles.columnPlayers}>
                    <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Round 2 / L64</Text>
                  </View>

                  <View style={styles.columnLine}>
                  </View>

                  {/* L32 Headline */}
                  <View style={styles.columnPlayers}>
                    <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Round 3 / L32</Text>
                  </View>

                  <View style={styles.columnLine}>
                  </View>

                  {/* L16 Headline */}
                  <View style={styles.columnPlayers}>
                    <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Round 4 / L16</Text>
                  </View>

                  <View style={styles.columnLine}>
                  </View>

                  {/* L8 Headline */}
                  <View style={styles.columnPlayers}>
                    <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Quarterfinal / L8</Text>
                  </View>

                  <View style={styles.columnLine}>
                  </View>

                  {/* L4 Headline */}
                  <View style={styles.columnPlayers}>
                    <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Semifinal / L4</Text>
                  </View>

                  <View style={styles.columnLine}>
                  </View>

                  {/* L2 Headline */}
                  <View style={styles.columnPlayers}>
                    <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Final / L2</Text>
                  </View>


                </View>

                <View style={{width: '100%', height: '97.5%', flexDirection: 'row'}}>

                  {/*Spalte L128*/}
                  <View style={styles.columnPlayers}>

                    {/* Spiel 1 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[0] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[0])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[1] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[1])}</Text>
                      </View>

                    </View>

                    {/* Spiel 2 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[2] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[2])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[3] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[3])}</Text>
                      </View>

                    </View>

                    {/* Spiel 3 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[4] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[4])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[5] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[5])}</Text>
                      </View>

                    </View>

                    {/* Spiel 4 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[6] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[6])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[7] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[7])}</Text>
                      </View>

                    </View>

                    {/* Spiel 5 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[8] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[8])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[9] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[9])}</Text>
                      </View>

                    </View>

                    {/* Spiel 6 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[10] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[10])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[11] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[11])}</Text>
                      </View>

                    </View>

                    {/* Spiel 7 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[12] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[12])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[13] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[13])}</Text>
                      </View>

                    </View>

                    {/* Spiel 8 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[14] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[14])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[15] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[15])}</Text>
                      </View>

                    </View>

                    {/* Spiel 9 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[16] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[16])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[17] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[17])}</Text>
                      </View>

                    </View>

                    {/* Spiel 10 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[18] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[18])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[19] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[19])}</Text>
                      </View>

                    </View>

                    {/* Spiel 11 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[20] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[20])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[21] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[21])}</Text>
                      </View>

                    </View>

                    {/* Spiel 12 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[22] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[22])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[23] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[23])}</Text>
                      </View>

                    </View>

                    {/* Spiel 13 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[24] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[24])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[25] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[25])}</Text>
                      </View>

                    </View>

                    {/* Spiel 14 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[26] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[26])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[27] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[27])}</Text>
                      </View>

                    </View>

                    {/* Spiel 15 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[28] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[28])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[29] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[29])}</Text>
                      </View>

                    </View>

                    {/* Spiel 16 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[30] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[30])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[31] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[31])}</Text>
                      </View>

                    </View>

                    {/* Spiel 17 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[32] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[32])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[33] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[33])}</Text>
                      </View>

                    </View>

                    {/* Spiel 18 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[34] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[34])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[35] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[35])}</Text>
                      </View>

                    </View>

                    {/* Spiel 19 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[36] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[36])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[37] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[37])}</Text>
                      </View>

                    </View>

                    {/* Spiel 20 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[38] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[38])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[39] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[39])}</Text>
                      </View>

                    </View>

                    {/* Spiel 21 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[40] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[40])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[41] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[41])}</Text>
                      </View>

                    </View>

                    {/* Spiel 22 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[42] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[42])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[43] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[43])}</Text>
                      </View>

                    </View>

                    {/* Spiel 23 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[44] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[44])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[45] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[45])}</Text>
                      </View>

                    </View>

                    {/* Spiel 24 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[46] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[46])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[47] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[47])}</Text>
                      </View>

                    </View>

                    {/* Spiel 25 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[48] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[48])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[49] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[49])}</Text>
                      </View>

                    </View>

                    {/* Spiel 26 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[50] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[50])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[51] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[51])}</Text>
                      </View>

                    </View>

                    {/* Spiel 27 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[52] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[52])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[53] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[53])}</Text>
                      </View>

                    </View>

                    {/* Spiel 28 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[54] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[54])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[55] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[55])}</Text>
                      </View>

                    </View>

                    {/* Spiel 29 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[56] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[56])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[57] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[57])}</Text>
                      </View>

                    </View>

                    {/* Spiel 30 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[58] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[58])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[59] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[59])}</Text>
                      </View>

                    </View>

                    {/* Spiel 31 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[60] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[60])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[61] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[61])}</Text>
                      </View>

                    </View>

                    {/* Spiel 32 in L128 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[62] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[62])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L128[63] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L128[63])}</Text>
                      </View>

                    </View>
                  
                  </View>

                  {/*L128 Verbindung L64*/}
                  <View style={styles.columnLine}>

                    {/* Linie 1 in L128 */}
                    <View style={{...styles.rowLine, height: '1.5625%'}}/>

                    {/* Linie 2 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 3 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 4 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 5 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 6 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 7 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 8 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 9 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 10 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 11 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 12 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 13 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 14 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 15 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 16 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 17 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 18 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 19 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 20 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 21 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 22 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 23 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 24 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 25 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 26 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 27 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 28 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 29 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 30 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 31 in L128 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 32 in L128 */}
                    <View style={styles.rowLine}/>



                  </View>

                  {/*Spalte L64*/}
                  <View style={styles.columnPlayers}>

                    {/* Spiel 1 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[0] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[0])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[1] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[1])}</Text>
                      </View>

                    </View>

                    {/* Spiel 2 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[2] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[2])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[3] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[3])}</Text>
                      </View>

                    </View>

                    {/* Spiel 3 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[4] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[4])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[5] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[5])}</Text>
                      </View>

                    </View>

                    {/* Spiel 4 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[6] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[6])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[7] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[7])}</Text>
                      </View>

                    </View>

                    {/* Spiel 5 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[8] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[8])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[9] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[9])}</Text>
                      </View>

                    </View>

                    {/* Spiel 6 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[10] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[10])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[11] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[11])}</Text>
                      </View>

                    </View>

                    {/* Spiel 7 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[12] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[12])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[13] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[13])}</Text>
                      </View>

                    </View>

                    {/* Spiel 8 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[14] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[14])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[15] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[15])}</Text>
                      </View>

                    </View>

                    {/* Spiel 9 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[16] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[16])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[17] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[17])}</Text>
                      </View>

                    </View>

                    {/* Spiel 10 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[18] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[18])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[19] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[19])}</Text>
                      </View>

                    </View>

                    {/* Spiel 11 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[20] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[20])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[21] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[21])}</Text>
                      </View>

                    </View>

                    {/* Spiel 12 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[22] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[22])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[23] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[23])}</Text>
                      </View>

                    </View>

                    {/* Spiel 13 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[24] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[24])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[25] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[25])}</Text>
                      </View>

                    </View>

                    {/* Spiel 14 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[26] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[26])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[27] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[27])}</Text>
                      </View>

                    </View>

                    {/* Spiel 15 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[28] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[28])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[29] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[29])}</Text>
                      </View>

                    </View>

                    {/* Spiel 16 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[30] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[30])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[31] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[31])}</Text>
                      </View>

                    </View>

                    {/* Spiel 17 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[32] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[32])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[33] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[33])}</Text>
                      </View>

                    </View>

                    {/* Spiel 18 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[34] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[34])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[35] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[35])}</Text>
                      </View>

                    </View>

                    {/* Spiel 19 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[36] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[36])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[37] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[37])}</Text>
                      </View>

                    </View>

                    {/* Spiel 20 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[38] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[38])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[39] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[39])}</Text>
                      </View>

                    </View>

                    {/* Spiel 21 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[40] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[40])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[41] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[41])}</Text>
                      </View>

                    </View>

                    {/* Spiel 22 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[42] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[42])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[43] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[43])}</Text>
                      </View>

                    </View>

                    {/* Spiel 23 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[44] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[44])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[45] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[45])}</Text>
                      </View>

                    </View>

                    {/* Spiel 24 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[46] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[46])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[47] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[47])}</Text>
                      </View>

                    </View>

                    {/* Spiel 25 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[48] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[48])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[49] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[49])}</Text>
                      </View>

                    </View>

                    {/* Spiel 26 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[50] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[50])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[51] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[51])}</Text>
                      </View>

                    </View>

                    {/* Spiel 27 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[52] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[52])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[53] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[53])}</Text>
                      </View>

                    </View>

                    {/* Spiel 28 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[54] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[54])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[55] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[55])}</Text>
                      </View>

                    </View>

                    {/* Spiel 29 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[56] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[56])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[57] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[57])}</Text>
                      </View>

                    </View>

                    {/* Spiel 30 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[58] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[58])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[59] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[59])}</Text>
                      </View>

                    </View>

                    {/* Spiel 31 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[60] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[60])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[61] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[61])}</Text>
                      </View>

                    </View>

                    {/* Spiel 32 in L64 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[62] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[62])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L64[63] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L64[63])}</Text>
                      </View>

                    </View>
                  
                  </View>

                  {/*L64 Verbindung L32 Teil 1*/}
                  <View style={{...styles.columnLine , width: '1%'}}>

                    {/* Linie 1 in L64 */}
                    <View style={{...styles.rowLine, height: '1.5625%'}}/>

                    {/* Linie 2 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 3 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 4 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 5 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 6 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 7 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 8 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 9 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 10 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 11 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 12 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 13 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 14 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 15 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 16 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 17 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 18 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 19 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 20 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 21 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 22 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 23 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 24 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 25 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 26 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 27 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 28 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 29 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 30 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 31 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 32 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>



                  </View>

                  {/*L64 Verbindung L32 Teil 2*/}
                  <View style={{...styles.columnLine , width: '1%'}}>

                    {/* Linie 1 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 2 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 3 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 4 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 5 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 6 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 7 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 8 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 9 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 10 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 11 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 12 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 13 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 14 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 15 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 16 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 17 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 18 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 19 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 20 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 21 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 22 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 23 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 24 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 25 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 26 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 27 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 28 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 29 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 30 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 31 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 32 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>



                  </View>

                  {/*Spalte L32*/}
                  <View style={styles.columnPlayers}>

                    {/* Platzhalter in L32 */}
                    <View style={{...styles.rowPlayers, height: '1.5625%'}}/>

                    {/* Spiel 1 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[0] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[0])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[1] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[1])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 2 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[2] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[2])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[3] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[3])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 3 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[4] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[4])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[5] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[5])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 4 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[6] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[6])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[7] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[7])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 5 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[8] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[8])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[9] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[9])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 6 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[10] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[10])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[11] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[11])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 7 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[12] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[12])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[13] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[13])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 8 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[14] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[14])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[15] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[15])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 9 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[16] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[16])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[17] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[17])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 10 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[18] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[18])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[19] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[19])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 11 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[20] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[20])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[21] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[21])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 12 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[22] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[22])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[23] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[23])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 13 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[24] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[24])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[25] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[25])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 14 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[26] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[26])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[27] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[27])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 15 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[28] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[28])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[29] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[29])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L32 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 16 in L32 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[30] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[30])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L32[31] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L32[31])}</Text>
                      </View>

                    </View>
                  
                  </View>

                  {/*L32 Verbindung L16 Teil 1*/}
                  <View style={{...styles.columnLine , width: '1%'}}>

                    {/* Linie 1 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 2 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 3 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 4 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 5 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 6 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 7 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 8 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 9 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 10 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 11 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 12 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 13 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 14 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 15 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 16 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 17 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 18 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 19 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 20 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 21 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 22 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 23 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 24 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 25 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 26 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 27 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 28 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 29 in L64 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 30 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 31 in L64 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 32 in L64 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                  </View>

                  {/*L32 Verbindung L16 Teil 2*/}
                  <View style={{...styles.columnLine , width: '1%'}}>

                    {/* Linie 1 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 2 in L32 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 3 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 4 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 5 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 6 in L32 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 7 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 8 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 9 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 10 in L32 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 11 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 12 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 13 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 14 in L32 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 15 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 16 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 17 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 18 in L32 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 19 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 20 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 21 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 22 in L32 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 23 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 24 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 25 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 26 in L32 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 27 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 28 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 29 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 30 in L32 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 31 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 32 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                  </View>

                  {/*Spalte L16*/}
                  <View style={styles.columnPlayers}>

                    {/* Platzhalter in L16 */}
                    <View style={{...styles.rowPlayers, height: '1.5625%'}}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 1 in L16 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[0] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[0])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[1] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[1])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 2 in L16 */}
                    <View style={styles.rowPlayers}>

                    <View style={{...styles.playerButton, backgroundColor: ((L16[2] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[2])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[3] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[3])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 3 in L16 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[4] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[4])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[5] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[5])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 4 in L16 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[6] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[6])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[7] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[7])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 5 in L16 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[8] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[8])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[9] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[9])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 6 in L16 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[10] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[10])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[11] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[11])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 7 in L16 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[12] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[12])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[13] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[13])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L16 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 8 in L16 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[14] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[14])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L16[15] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L16[15])}</Text>
                      </View>

                    </View>
                  
                  </View>

                  {/*L16 Verbindung L8 Teil 1*/}
                  <View style={{...styles.columnLine , width: '1%'}}>

                    {/* Linie 1 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 2 in L16 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 3 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 4 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 5 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 6 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 1}}/>

                    {/* Linie 7 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 8 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 9 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 10 in L16 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 11 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 12 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 13 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 14 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 1}}/>

                    {/* Linie 15 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 16 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 17 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 18 in L16 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 19 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 20 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 21 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 22 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1}}/>

                    {/* Linie 23 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 24 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 25 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 26 in L16 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 27 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 28 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 29 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 30 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 1}}/>

                  </View>

                  {/*L16 Verbindung L8 Teil 2*/}
                  <View style={{...styles.columnLine , width: '1%'}}>

                    {/* Linie 1 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 2 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 3 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 4 in L32 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 5 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 6 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 7 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 8 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 9 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 10 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 11 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 12 in L32 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 13 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 14 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 15 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 16 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 17 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 18 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 19 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 20 in L32 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 21 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 22 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 23 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 24 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 25 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 26 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 27 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 28 in L32 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 29 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 30 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 31 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 32 in L32 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                  </View>

                  {/*Spalte L8*/}
                  <View style={styles.columnPlayers}>

                    {/* Platzhalter in L8 */}
                    <View style={{...styles.rowPlayers, height: '1.5625%'}}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 1 in L8 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L8[0] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L8[0])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L8[1] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L8[1])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 2 in L8 */}
                    <View style={styles.rowPlayers}>

                    <View style={{...styles.playerButton, backgroundColor: ((L8[2] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L8[2])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L8[3] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L8[3])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 3 in L8 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L8[4] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L8[4])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L8[5] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L8[5])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L8 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 4 in L8 */}
                    <View style={styles.rowPlayers}>

                    <View style={{...styles.playerButton, backgroundColor: ((L8[6] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L8[6])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L8[7] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L8[7])}</Text>
                      </View>

                    </View>
                  
                  </View>

                  {/*L8 Verbindung L4 Teil 1*/}
                  <View style={{...styles.columnLine , width: '1%'}}>

                    {/* Linie 1 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 2 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 3 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 4 in L16 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 5 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 6 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 7 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 8 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 9 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 10 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 11 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 12 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 1}}/>

                    {/* Linie 13 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 14 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 15 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 16 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 17 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 18 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 19 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 20 in L16 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 21 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 22 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 23 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 24 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 25 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 26 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 27 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 28 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 1}}/>

                  </View>

                  {/*L8 Verbindung L4 Teil 2*/}
                  <View style={{...styles.columnLine , width: '1%'}}>

                    {/* Linie 1 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 2 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 3 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 4 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 5 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 6 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 7 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 8 in L8 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 9 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 10 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 11 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 12 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 13 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 14 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 15 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 16 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 17 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 18 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 19 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 20 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 21 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 22 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 23 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 24 in L8 */}
                    <View style={styles.rowLine}/>

                  </View>

                  {/*Spalte L4*/}
                  <View style={styles.columnPlayers}>

                    {/* Platzhalter in L4 */}
                    <View style={{...styles.rowPlayers, height: '1.5625%'}}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 1 in L4 */}
                    <View style={styles.rowPlayers}>

                    <View style={{...styles.playerButton, backgroundColor: ((L4[0] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L4[0])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L4[1] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L4[1])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={{...styles.rowPlayers, justifyContent: 'center', alignItems: 'center', paddingBottom: 2}}>

                      <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Powered by</Text>

                    </View>

                    {/* Platzhalter in L4 */}
                    <View style={{...styles.rowPlayers}}>

                      {/* MyDartCoach Logo */}
                      <Image source={require('./images/MyDartCoach Logo.png')}
                        style={{
                            aspectRatio: 2,
                            width: "100%",
                            height: null,
                            resizeMode: 'contain',
                            borderRadius: 0,
                        }}
                      />

                    </View>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L4 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 2 in L4 */}
                    <View style={styles.rowPlayers}>

                    <View style={{...styles.playerButton, backgroundColor: ((L4[2] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L4[2])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L4[3] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L4[3])}</Text>
                      </View>

                    </View>
                  
                  </View>

                  {/*L4 Verbindung L2 Teil 1*/}
                  <View style={{...styles.columnLine , width: '1%'}}>

                    {/* Linie 1 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 2 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 3 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 4 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 5 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 6 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 7 in L16 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 8 in L16 */}
                    <View style={styles.rowLine}/>

                    {/* Linie 9 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 10 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 11 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 12 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 13 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 14 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 15 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 16 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 17 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 18 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 19 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 20 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 21 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 22 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 23 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 0}}/>

                    {/* Linie 24 in L16 */}
                    <View style={{...styles.rowLine, borderRightWidth: 1, borderBottomWidth: 1}}/>

                  </View>

                  {/*L4 Verbindung L2 Teil 2*/}
                  <View style={{...styles.columnLine , width: '1%'}}>

                    {/* Linie 1 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 2 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 3 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 4 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 5 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 6 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 7 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 8 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 9 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 10 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 11 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 12 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 13 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 14 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 15 in L8 */}
                    <View style={{...styles.rowLine, borderBottomWidth: 0}}/>

                    {/* Linie 16 in L8 */}
                    <View style={styles.rowLine}/>

                  </View>

                  {/*Spalte L2*/}
                  <View style={styles.columnPlayers}>

                    {/* Platzhalter in L2 */}
                    <View style={{...styles.rowPlayers, height: '1.5625%'}}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Spiel 1 in L2 */}
                    <View style={styles.rowPlayers}>

                      <View style={{...styles.playerButton, backgroundColor: ((L2[0] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L2[0])}</Text>
                      </View>

                      <View style={{...styles.playerButton, backgroundColor: ((L2[1] == L1[0] && L1[0] != 0) ? winnerGoldColorForFullView : frontColor)}}>
                        <Text style={{...styles.playerText, fontSize: getUsableHeight("pText")}}>{getParticipantName(L2[1])}</Text>
                      </View>

                    </View>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Tippen starten Button 1/2*/}
                    {
                      getUsableHeight("smallScreen") == true ? 

                        <View style={{...styles.rowPlayers, height: '6.25%'}}>

                        {
                          finished == false ?

                          <TouchableOpacity onPress={() => startPrediction()} style={{width: '100%', height: '100%', backgroundColor: "green", maxWidth: 300, maxHeight: 50, borderRadius: 50, justifyContent: 'center', alignItems: 'center'}}>

                            <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Start prediction</Text>

                          </TouchableOpacity>

                          :

                          <TouchableOpacity onPress={() => createNewPDF()} style={{width: '100%', height: '100%', backgroundColor: "green", maxWidth: 300, maxHeight: 50, borderRadius: 50, justifyContent: 'center', alignItems: 'center'}}>

                            <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Download PDF</Text>

                          </TouchableOpacity>
                        }

                          

                        </View>

                      :

                        <View style={styles.rowPlayers}/>
                    }

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Platzhalter in L2 */}
                    <View style={styles.rowPlayers}/>

                    {/* Tippen starten Button 2/2*/}
                    {
                      getUsableHeight("smallScreen") == false ? 

                        <View style={{...styles.rowPlayers, height: '6.25%'}}>

                        {
                          finished == false ?

                          <TouchableOpacity onPress={() => startPrediction()} style={{width: '100%', height: '100%', backgroundColor: "green", maxWidth: 300, maxHeight: 50, borderRadius: 50, justifyContent: 'center', alignItems: 'center'}}>

                            <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Start prediction</Text>

                          </TouchableOpacity>

                          :

                          <TouchableOpacity onPress={() => createNewPDF()} style={{width: '100%', height: '100%', backgroundColor: "green", maxWidth: 300, maxHeight: 50, borderRadius: 50, justifyContent: 'center', alignItems: 'center'}}>

                            <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Download PDF</Text>

                          </TouchableOpacity>
                        }

                          

                        </View>

                      :

                        <View style={styles.rowPlayers}/>
                    }

                  </View>

                </View>
              
              </View>

            :

              <View style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showCurrentInformationModal}
                  onRequestClose={() => setShowCurrentInformationModal(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                      <Pressable style={styles.closeIcon} onPress={() => setShowCurrentInformationModal(false)}>
                        <Text style={styles.closeIconText}>X</Text>
                      </Pressable>

                      <View style={{width: '80%', aspectRatio: 16/9, borderRadius: 10, overflow: 'hidden', maxWidth: 1800, justifyContent: "center", alignItems: "center"}}>

                        <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")+10)}}>{currentInformationName ? (currentInformationName + " (" + currentInformationCountry + ")") : ""}</Text>
                        <Text style={{...styles.playerInformationText, fontSize: (getUsableHeight("piText")+10)}}>{currentInformationInformation}</Text>

                      </View>

                    </View>
                  </View>
              </Modal>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showBF1Ad}
                  onRequestClose={() => setShowBF1Ad(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                    <Pressable style={styles.closeIcon} onPress={() => setShowBF1Ad(false)}>
                      <Text style={styles.closeIconText}>X</Text>
                    </Pressable>

                    <Pressable style={{width: '80%', aspectRatio: 16/9, borderRadius: 10, overflow: 'hidden', maxWidth: 1800}}
                     onPress={() => Linking.openURL('http://www.bigfish170.com/')}>
                      <Image
                        source={require('./images/ad1.jpg')}
                        style={{width: '100%', height: '100%'}}
                        resizeMode="cover"
                      />
                    </Pressable>

                    </View>
                  </View>
              </Modal>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showBF2Ad}
                  onRequestClose={() => setShowBF2Ad(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                    <Pressable style={styles.closeIcon} onPress={() => setShowBF2Ad(false)}>
                      <Text style={styles.closeIconText}>X</Text>
                    </Pressable>

                    <Pressable style={{width: '80%', aspectRatio: 16/9, borderRadius: 10, overflow: 'hidden', maxWidth: 1800}}
                     onPress={() => Linking.openURL('http://www.bigfish170.com/')}>
                      <Image
                        source={require('./images/ad2.jpg')}
                        style={{width: '100%', height: '100%'}}
                        resizeMode="cover"
                      />
                    </Pressable>

                    </View>
                  </View>
              </Modal>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showCO1Ad}
                  onRequestClose={() => setShowCO1Ad(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                    <Pressable style={styles.closeIcon} onPress={() => setShowCO1Ad(false)}>
                      <Text style={styles.closeIconText}>X</Text>
                    </Pressable>

                    <Pressable style={{width: '80%', aspectRatio: 16/9, borderRadius: 10, overflow: 'hidden', maxWidth: 1800}}
                     onPress={() => Linking.openURL('https://open.spotify.com/show/4HA5DSRJLSMmVMHo35fGYh')}>
                      <Image
                        source={require('./images/ad3.jpg')}
                        style={{width: '100%', height: '100%'}}
                        resizeMode="cover"
                      />
                    </Pressable>

                    </View>
                  </View>
              </Modal>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showBF1AdEN}
                  onRequestClose={() => setShowBF1AdEN(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                    <Pressable style={styles.closeIcon} onPress={() => setShowBF1AdEN(false)}>
                      <Text style={styles.closeIconText}>X</Text>
                    </Pressable>

                    <Pressable style={{width: '80%', aspectRatio: 16/9, borderRadius: 10, overflow: 'hidden', maxWidth: 1800}}
                     onPress={() => Linking.openURL('http://www.bigfish170.com/')}>
                      <Image
                        source={require('./images/ad1EN.jpg')}
                        style={{width: '100%', height: '100%'}}
                        resizeMode="cover"
                      />
                    </Pressable>

                    </View>
                  </View>
              </Modal>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showBF2AdEN}
                  onRequestClose={() => setShowBF2AdEN(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                    <Pressable style={styles.closeIcon} onPress={() => setShowBF2AdEN(false)}>
                      <Text style={styles.closeIconText}>X</Text>
                    </Pressable>

                    <Pressable style={{width: '80%', aspectRatio: 16/9, borderRadius: 10, overflow: 'hidden', maxWidth: 1800}}
                     onPress={() => Linking.openURL('http://www.bigfish170.com/')}>
                      <Image
                        source={require('./images/ad2EN.jpg')}
                        style={{width: '100%', height: '100%'}}
                        resizeMode="cover"
                      />
                    </Pressable>

                    </View>
                  </View>
              </Modal>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showCO1AdEN}
                  onRequestClose={() => setShowCO1AdEN(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                    <Pressable style={styles.closeIcon} onPress={() => setShowCO1AdEN(false)}>
                      <Text style={styles.closeIconText}>X</Text>
                    </Pressable>

                    <Pressable style={{width: '80%', aspectRatio: 16/9, borderRadius: 10, overflow: 'hidden', maxWidth: 1800}}
                     onPress={() => Linking.openURL('https://mydartcoach.com/en/mydartcoach-app-1/')}>
                      <Image
                        source={require('./images/ad3EN.jpg')}
                        style={{width: '100%', height: '100%'}}
                        resizeMode="cover"
                      />
                    </Pressable>

                    </View>
                  </View>
              </Modal>

                {
                  currentRound == 4 ?

                  <View style={{width: (getUsableHeight("smallScreen") ? '70%' : '80%'), height: '80%', backgroundColor: frontColor, justifyContent: 'center', alignItems: 'center', borderRadius: 10, flexDirection: 'row'}}>

                    {/* LINIE 1*/}
                    <View style={{height: '100%', width: '6.33%'}}>

                      <View style={{...styles.predictionSection}}/>
                      <View style={{...styles.predictionSection, borderBottomWidth: (currentRound == 128 ? 0 : 5), borderColor: backgroundColor}}/>
                      <View style={{...styles.predictionSection, borderBottomWidth: (currentRound == 128 ? 0 : 5), borderColor: backgroundColor}}/>

                    </View>

                    {/* TIPS */}
                    <View style={{height: '100%', width: '45%', justifyContent: 'center'}}>

                      {/* HEADLINE */}  
                      <View style={{...styles.predictionSection, height: '10%'}}>

                        {
                          <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{"Semifinal"}</Text>
                        }

                      </View>

                      {/* FILLER */}  
                      <View style={styles.predictionSection}/>

                      {/* PREDICTION SECTION 1*/}  
                      <View style={styles.predictionSection}>

                        {/* Spieler 1 */}
                        <View style={styles.predictionPlayerButton}>

                          <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                              currentPreditcionOne != 0 ?

                              <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionOne)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }
                                    
                          </View>

                          <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                            <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionOne)}</Text>

                          </View>

                          <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                          {
                              currentPreditcionOne > 32 || currentRound != 128 ?

                              <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionOne, 0)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="caretright" size={getUsableHeight("arrow")} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }

                          </View>

                        </View>

                        {/* Spieler 2 */}
                        <View style={styles.predictionPlayerButton}>

                          <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                              currentPreditcionTwo != 0 ?

                              <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionTwo)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }
                                    
                          </View>

                          <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                            <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionTwo)}</Text>

                          </View>

                          <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                              currentPreditcionTwo> 32 || currentRound != 128 ?

                              <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionTwo, 0)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="caretright" size={getUsableHeight("arrow")} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }

                          </View>

                        </View>

                      </View>


                      {/* PREDICTION SECTION 2*/}  
                      <View style={styles.predictionSection}>

                        {/* Spieler 3 */}
                        <View style={styles.predictionPlayerButton}>

                          <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                          {
                              currentPreditcionThree != 0 ?

                              <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionThree)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }
                                    
                          </View>

                          <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                            <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionThree)}</Text>

                          </View>

                          <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                          {
                              currentPreditcionThree> 32 || currentRound != 128 ?

                              <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionThree, 1)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="caretright" size={getUsableHeight("arrow")} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }

                          </View>

                        </View>

                        {/* Spieler 4 */}
                        <View style={styles.predictionPlayerButton}>

                          <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                          {
                              currentPreditcionFour != 0 ?

                              <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionFour)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }
                                    
                          </View>

                          <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                            <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionFour)}</Text>

                          </View>

                          <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                          {
                              currentPreditcionFour> 32 || currentRound != 128 ?

                              <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionFour, 1)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="caretright" size={getUsableHeight("arrow")} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }

                          </View>

                        </View>

                      </View>

                      {/* FILLER */}  
                      <View style={{...styles.predictionSection, height: '30%'}}/>

                    </View>

                    {/* LINIE 2*/}
                    <View style={{height: '100%', width: '6.33%', justifyContent: 'center', flexDirection: 'row'}}>

                      <View style={{width: '50%', height: '100%'}}>

                        <View style={{...styles.predictionSection}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor, borderRightWidth: 5}}/>

                      </View>

                      <View style={{width: '50%', height: '100%'}}>

                        <View style={{...styles.predictionSection}}/>
                        <View style={{...styles.predictionSection, height: '10%'}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>

                      </View>

                    </View>

                    {/* Fortführung Tips */}
                    <View style={{height: '100%', width: '35%', justifyContent: 'center'}}>

                      {/* HEADLINE */}  
                      <View style={{...styles.predictionSection, height: '10%'}}>

                        {
                          <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{"Final"}</Text>
                        }

                      </View>

                      {/* FILLER*/} 
                      <View style={{...styles.predictionSection, height: '30%'}}/>

                      {/* PREDICTION SECTION 1*/}  
                      <View style={{...styles.predictionSection}}>

                        {/* Spieler 1 */}
                        <View style={styles.predictionPlayerButton}>

                          <View style={{width: '100%', height: '100%', justifyContent: 'center', paddingLeft: '3%'}}>

                            <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentFinalPredictionOne)}</Text>

                          </View>

                        </View>

                        {/* Spieler 2 */}
                        <View style={styles.predictionPlayerButton}>

                          <View style={{width: '100%', height: '100%', justifyContent: 'center', paddingLeft: '3%'}}>

                            <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentFinalPredictionTwo)}</Text>

                          </View>

                        </View>

                      </View>

                      {/* FILLER*/} 
                    <View style={{...styles.predictionSection, height: '40%'}}/>

                    </View>

                    {/* LINIE 3*/}
                    <View style={{height: '100%', width: '6.33%', justifyContent: 'center', flexDirection: 'row'}}>

                    </View>

                  </View>

                  :
                
                  (
                    currentRound == 2 ?

                    <View style={{width: (getUsableHeight("smallScreen") ? '70%' : '80%'), height: '80%', backgroundColor: frontColor, justifyContent: 'center', alignItems: 'center', borderRadius: 10, flexDirection: 'row'}}>

                      {/* LINIE 1*/}
                      <View style={{height: '100%', width: '6.33%'}}>

                        <View style={{...styles.predictionSection, height: '30%'}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: (currentRound == 128 ? 0 : 5), borderColor: backgroundColor}}/>

                      </View>

                      {/* TIPS */}
                      <View style={{height: '100%', width: '45%', justifyContent: 'center'}}>

                        {/* HEADLINE */}  
                        <View style={{...styles.predictionSection, height: '10%'}}>

                          {
                            <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{"Final"}</Text>
                          }

                        </View>

                        {/* FILLER */}  
                        <View style={{...styles.predictionSection, height: '30%'}}/>

                        {/* PREDICTION SECTION 1*/}  
                        <View style={styles.predictionSection}>

                          {/* Spieler 1 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                              {
                                currentPreditcionOne != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionOne)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionOne)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionOne > 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionOne, 0)}} style={{width: '100%', height: '100%', backgroundColor: winnerYellowColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <FontAwesome5 name="crown" size={getUsableHeight("arrow")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                          {/* Spieler 2 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                              {
                                currentPreditcionTwo != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionTwo)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionTwo)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                              {
                                currentPreditcionTwo> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionTwo, 0)}} style={{width: '100%', height: '100%', backgroundColor: winnerYellowColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <FontAwesome5 name="crown" size={getUsableHeight("arrow")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                        </View>

                        {/* FILLER */}  
                        <View style={{...styles.predictionSection, height: '40%'}}/>

                      </View>

                      {/* LINIE 2*/}
                      <View style={{height: '100%', width: '6.33%', justifyContent: 'center', flexDirection: 'row'}}>

                        <View style={{width: '100%', height: '100%'}}>

                          <View style={{...styles.predictionSection}}/>
                          <View style={{...styles.predictionSection, height: '10%'}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>

                        </View>

                      </View>

                      {/* Fortführung Tips */}
                      <View style={{height: '100%', width: '35%', justifyContent: 'center'}}>

                        {/* HEADLINE */}  
                        <View style={{...styles.predictionSection, height: '10%'}}>

                          {
                            <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{"Winner"}</Text>
                          }

                        </View>

                        {/* FILLER*/} 
                        <View style={{...styles.predictionSection, height: '30%'}}/>

                        {/* PREDICTION SECTION 1*/}  
                        <View style={{...styles.predictionSection}}>

                          {/* Winner */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '100%', height: '100%', justifyContent: 'center', paddingLeft: '3%'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentFinalPredictionOne)}</Text>

                            </View>

                          </View>

                        </View>

                        {/* FILLER*/} 
                      <View style={{...styles.predictionSection, height: '40%'}}/>

                      </View>

                      {/* LINIE 3*/}
                      <View style={{height: '100%', width: '6.33%', justifyContent: 'center', flexDirection: 'row'}}>

                      </View>

                    </View>

                    :

                    <View style={{width: (getUsableHeight("smallScreen") ? '70%' : '80%'), height: '80%', backgroundColor: frontColor, justifyContent: 'center', alignItems: 'center', borderRadius: 10, flexDirection: 'row'}}>

                      {/* LINIE 1*/}
                      <View style={{height: '100%', width: '6.33%'}}>

                        <View style={{...styles.predictionSection, borderBottomWidth: (currentRound == 128 ? 0 : 5), borderColor: backgroundColor}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: (currentRound == 128 ? 0 : 5), borderColor: backgroundColor}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: (currentRound == 128 ? 0 : 5), borderColor: backgroundColor}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: (currentRound == 128 ? 0 : 5), borderColor: backgroundColor}}/>

                      </View>

                      {/* TIPS */}
                      <View style={{height: '100%', width: '45%', justifyContent: 'center'}}>

                        {/* HEADLINE */}  
                        <View style={{...styles.predictionSection, height: '10%'}}>

                          {
                            currentRound <= 8 ?

                            <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{"L"+currentRound}</Text>

                            :

                            <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{"L"+currentRound + " " + (roundStatus+1) + "/" + currentRound/8}</Text>
                          }

                        </View>

                        {/* PREDICTION SECTION 1*/}  
                        <View style={styles.predictionSection}>

                          {/* Spieler 1 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                              {
                                currentPreditcionOne != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionOne)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionOne)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionOne > 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionOne, 0)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                          {/* Spieler 2 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                              {
                                currentPreditcionTwo != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionTwo)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionTwo)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                              {
                                currentPreditcionTwo> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionTwo, 0)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                        </View>


                        {/* PREDICTION SECTION 2*/}  
                        <View style={styles.predictionSection}>

                          {/* Spieler 3 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                                currentPreditcionThree != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionThree)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionThree)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionThree> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionThree, 1)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                          {/* Spieler 4 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                                currentPreditcionFour != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionFour)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionFour)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionFour> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionFour, 1)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                        </View>


                        {/* PREDICTION SECTION 3*/}  
                        <View style={styles.predictionSection}>

                          {/* Spieler 5 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                                currentPreditcionFive != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionFive)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionFive)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionFive> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionFive, 2)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                          {/* Spieler 6 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                                currentPreditcionSix != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionSix)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionSix)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionSix> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionSix, 2)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                        </View>


                        {/* PREDICTION SECTION 4*/}  
                        <View style={styles.predictionSection}>

                          {/* Spieler 7 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                                currentPreditcionSeven != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionSeven)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionSeven)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionSeven> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionSeven, 3)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                          {/* Spieler 8 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                                currentPreditcionEight != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformation(currentPreditcionEight)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentPreditcionEight)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionEight> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionEight, 3)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow")} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                        </View>

                        {/* FILLER */}  
                        <View style={{...styles.predictionSection, height: '10%'}}/>

                      </View>

                      {/* LINIE 2*/}
                      <View style={{height: '100%', width: '6.33%', justifyContent: 'center', flexDirection: 'row'}}>

                        <View style={{width: '50%', height: '100%'}}>

                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor, borderRightWidth: 5}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor, borderRightWidth: 5}}/>

                        </View>

                        <View style={{width: '50%', height: '100%'}}>

                          <View style={{...styles.predictionSection, height: '10%'}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>
                          <View style={{...styles.predictionSection}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>

                        </View>

                      </View>

                      {/* Fortführung Tips */}
                      <View style={{height: '100%', width: '35%', justifyContent: 'center'}}>

                        {/* HEADLINE */}  
                        <View style={{...styles.predictionSection, height: '10%'}}>

                          <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{"L" + currentRound/2}</Text>

                        </View>

                        {/* FILLER*/} 
                        <View style={{...styles.predictionSection, height: '10%'}}/>

                        {/* PREDICTION SECTION 1*/}  
                        <View style={{...styles.predictionSection}}>

                          {/* Spieler 1 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '100%', height: '100%', justifyContent: 'center', paddingLeft: '3%'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentFinalPredictionOne)}</Text>

                            </View>

                          </View>

                          {/* Spieler 2 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '100%', height: '100%', justifyContent: 'center', paddingLeft: '3%'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentFinalPredictionTwo)}</Text>

                            </View>

                          </View>

                        </View>

                        {/* FILLER*/} 
                        <View style={{...styles.predictionSection}}/>

                        {/* PREDICTION SECTION 2*/}  
                        <View style={{...styles.predictionSection}}>

                          {/* Spieler 1 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '100%', height: '100%', justifyContent: 'center', paddingLeft: '3%'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentFinalPredictionThree)}</Text>

                            </View>

                          </View>

                          {/* Spieler 2 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '100%', height: '100%', justifyContent: 'center', paddingLeft: '3%'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: getUsableHeight("ppText")}}>{getParticipantName(currentFinalPredictionFour)}</Text>

                            </View>

                          </View>

                        </View>

                        {/* FILLER*/} 
                        <View style={{...styles.predictionSection}}/>

                      </View>

                      {/* LINIE 3*/}
                      <View style={{height: '100%', width: '6.33%', justifyContent: 'center', flexDirection: 'row'}}>

                        <View style={{width: '50%', height: '100%'}}>

                          <View style={{...styles.predictionSection, height: '10%'}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>
                          <View style={{...styles.predictionSection, borderRightWidth: 5, borderColor: backgroundColor}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor, borderRightWidth: 5}}/>

                        </View>

                        <View style={{width: '50%', height: '100%'}}>

                          <View style={{...styles.predictionSection}}/>
                          <View style={{...styles.predictionSection, height: '10%'}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>

                        </View>

                      </View>

                    </View>
                  )

                }

                <View style={{width: (getUsableHeight("smallScreen") ? '70%' : '80%'), height: '15%', justifyContent: 'space-evenly', alignItems: 'center', flexDirection: 'row'}}>

                  {
                    currentRound == 128 && roundStatus == 0 ?

                    <View style={{width: '100%', height: '100%', maxWidth: 250, maxHeight: 50}}/>

                    :

                    <TouchableOpacity onPress={() => goBack()} style={{width: '100%', height: '100%', backgroundColor: frontColor, maxWidth: 250, maxHeight: 50, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>

                    <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Back</Text>

                    </TouchableOpacity>
                    
                  }

                  {/* MyDartCoach Logo */}
                  <Image source={require('./images/MyDartCoach_white.png')}
                    style={{
                        aspectRatio: 2,
                        width: 250,
                        height: null,
                        resizeMode: 'contain',
                        borderRadius: 0,
                    }}
                  />

                  <TouchableOpacity onPress={() => goNext()} style={{width: '100%', height: '100%', backgroundColor: frontColor, maxWidth: 250, maxHeight: 50, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>

                    <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Next</Text>

                  </TouchableOpacity>

                </View>

              </View>

          }

      </BrowserView>

      <MobileView style={styles.content}>
        
        {
          fullView == true ?

          activated === false ?

            <View style={{width: '100%', height: '100%', padding: '0.5%', justifyContent: 'center', alignItems: 'center'}}>

              <Text style={{...styles.headlineText, fontSize: (getUsableHeight("ppText") - 2), textAlign: 'center'}}>{"The Darts World Championship simulation of MyDartCoach is not yet online.\nThe simulation is planned to be available here on this website one hour after the end of the draw."}</Text>

            </View>

            :

            (
              finished == false ?

                <View style={{paddingHorizontal: 30, height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center'}}>

                  <MaterialIcons name="computer" size={100} color={"white"}/>
                  <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText"), paddingVertical: 50, textAlign: 'center'}}>Please open the PDC World Darts Championship 2025 simulation by MyDartCoach on a computer or laptop to see the schedule optimally adapted.</Text>
                
                  <TouchableOpacity onPress={() => startPrediction()} style={{width: '80%', height: '10%', backgroundColor: "green", maxWidth: 300, maxHeight: 50, borderRadius: 50, justifyContent: 'center', alignItems: 'center'}}>

                    <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Proceed anyway</Text>

                  </TouchableOpacity>

                </View>

                :

                <View style={{paddingHorizontal: 30, height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center'}}>

                  <MaterialIcons name="file-download" size={100} color={"white"}/>
                  <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText"), paddingVertical: 50, textAlign: 'center'}}>You can download your PDC World Championship fixture list as a PDF. The MyDartCoach team hopes you had fun predicting!</Text>
                
                  <TouchableOpacity onPress={() => createNewPDF()} style={{width: '80%', height: '10%', backgroundColor: "green", maxWidth: 300, maxHeight: 50, borderRadius: 50, justifyContent: 'center', alignItems: 'center'}}>

                    <Text style={{...styles.headlineText, fontSize: getUsableHeight("hlText")}}>Download PDF</Text>

                  </TouchableOpacity>

                </View>
            )

          :

          <View style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>

            <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showCurrentInformationModal}
                  onRequestClose={() => setShowCurrentInformationModal(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                      <Pressable style={styles.closeIcon} onPress={() => setShowCurrentInformationModal(false)}>
                        <Text style={styles.closeIconText}>X</Text>
                      </Pressable>

                      <View style={{width: '80%', aspectRatio: 16/9, borderRadius: 10, overflow: 'hidden', maxWidth: 1800, justifyContent: "center", alignItems: "center"}}>

                        <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")+4)}}>{currentInformationName ? (currentInformationName + " (" + currentInformationCountry + ")") : ""}</Text>
                        <Text style={{...styles.playerInformationText, fontSize: (getUsableHeight("piText")+4)}}>{currentInformationInformation}</Text>

                      </View>

                    </View>
                  </View>
              </Modal>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showBF1Ad}
                  onRequestClose={() => setShowBF1Ad(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                    <Pressable style={styles.closeIcon} onPress={() => setShowBF1Ad(false)}>
                      <Text style={styles.closeIconText}>X</Text>
                    </Pressable>

                    <Pressable style={{width: '80%', aspectRatio: 10/16, borderRadius: 10, overflow: 'hidden', maxWidth: 1800}}
                     onPress={() => Linking.openURL('http://www.bigfish170.com/')}>
                      <Image
                        source={require('./images/ad1Mobile.jpg')}
                        style={{width: '100%', height: '100%'}}
                        resizeMode="cover"
                      />
                    </Pressable>

                    </View>
                  </View>
              </Modal>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showBF2Ad}
                  onRequestClose={() => setShowBF2Ad(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                    <Pressable style={styles.closeIcon} onPress={() => setShowBF2Ad(false)}>
                      <Text style={styles.closeIconText}>X</Text>
                    </Pressable>

                    <Pressable style={{width: '80%', aspectRatio: 10/16, borderRadius: 10, overflow: 'hidden', maxWidth: 1800}}
                     onPress={() => Linking.openURL('http://www.bigfish170.com/')}>
                      <Image
                        source={require('./images/ad2Mobile.jpg')}
                        style={{width: '100%', height: '100%'}}
                        resizeMode="cover"
                      />
                    </Pressable>

                    </View>
                  </View>
              </Modal>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showCO1Ad}
                  onRequestClose={() => setShowCO1Ad(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                    <Pressable style={styles.closeIcon} onPress={() => setShowCO1Ad(false)}>
                      <Text style={styles.closeIconText}>X</Text>
                    </Pressable>

                    <Pressable style={{width: '80%', aspectRatio: 10/16, borderRadius: 10, overflow: 'hidden', maxWidth: 1800}}
                     onPress={() => Linking.openURL('https://open.spotify.com/show/4HA5DSRJLSMmVMHo35fGYh')}>
                      <Image
                        source={require('./images/ad3Mobile.jpg')}
                        style={{width: '100%', height: '100%'}}
                        resizeMode="cover"
                      />
                    </Pressable>

                    </View>
                  </View>
              </Modal>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showBF1AdEN}
                  onRequestClose={() => setShowBF1AdEN(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                    <Pressable style={styles.closeIcon} onPress={() => setShowBF1AdEN(false)}>
                      <Text style={styles.closeIconText}>X</Text>
                    </Pressable>

                    <Pressable style={{width: '80%', aspectRatio: 10/16, borderRadius: 10, overflow: 'hidden', maxWidth: 1800}}
                     onPress={() => Linking.openURL('http://www.bigfish170.com/')}>
                      <Image
                        source={require('./images/ad1ENMobile.jpg')}
                        style={{width: '100%', height: '100%'}}
                        resizeMode="cover"
                      />
                    </Pressable>

                    </View>
                  </View>
              </Modal>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showBF2AdEN}
                  onRequestClose={() => setShowBF2AdEN(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                    <Pressable style={styles.closeIcon} onPress={() => setShowBF2AdEN(false)}>
                      <Text style={styles.closeIconText}>X</Text>
                    </Pressable>

                    <Pressable style={{width: '80%', aspectRatio: 10/16, borderRadius: 10, overflow: 'hidden', maxWidth: 1800}}
                     onPress={() => Linking.openURL('http://www.bigfish170.com/')}>
                      <Image
                        source={require('./images/ad2ENMobile.jpg')}
                        style={{width: '100%', height: '100%'}}
                        resizeMode="cover"
                      />
                    </Pressable>

                    </View>
                  </View>
              </Modal>

              <Modal
                  animationType="slide"
                  transparent={true}
                  visible={showCO1AdEN}
                  onRequestClose={() => setShowCO1AdEN(false)}
                >
                  <View style={styles.modalContainer}>
                    <View style={styles.modalContent}>

                    <Pressable style={styles.closeIcon} onPress={() => setShowCO1AdEN(false)}>
                      <Text style={styles.closeIconText}>X</Text>
                    </Pressable>

                    <Pressable style={{width: '80%', aspectRatio: 10/16, borderRadius: 10, overflow: 'hidden', maxWidth: 1800}}
                     onPress={() => Linking.openURL('https://mydartcoach.com/en/mydartcoach-app-1/')}>
                      <Image
                        source={require('./images/ad3ENMobile.jpg')}
                        style={{width: '100%', height: '100%'}}
                        resizeMode="cover"
                      />
                    </Pressable>

                    </View>
                  </View>
              </Modal>

                <View style={{width: '95%', height: '10%', justifyContent: 'center', alignItems: 'center'}}>

                  {/* MyDartCoach Logo */}
                  <Image source={require('./images/MyDartCoach_white.png')}
                    style={{
                        aspectRatio: 2,
                        width: 200,
                        height: null,
                        resizeMode: 'contain',
                        borderRadius: 0,
                    }}
                  />

                </View>

                {
                  currentRound == 4 ?

                  <View style={{width: '95%', height: '75%', backgroundColor: frontColor, justifyContent: 'center', alignItems: 'center', borderRadius: 10, flexDirection: 'row'}}>

                    {/* LINIE 1*/}
                    <View style={{height: '100%', width: '10%'}}>

                      <View style={{...styles.predictionSection}}/>
                      <View style={{...styles.predictionSection, borderBottomWidth: (currentRound == 128 ? 0 : 5), borderColor: backgroundColor}}/>
                      <View style={{...styles.predictionSection, borderBottomWidth: (currentRound == 128 ? 0 : 5), borderColor: backgroundColor}}/>

                    </View>

                    {/* TIPS */}
                    <View style={{height: '100%', width: '80%', justifyContent: 'center'}}>

                      {/* HEADLINE */}  
                      <View style={{...styles.predictionSection, height: '10%'}}>

                        {
                          <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText") - 2)}}>{"Semifinal"}</Text>
                        }

                      </View>

                      {/* FILLER */}  
                      <View style={styles.predictionSection}/>

                      {/* PREDICTION SECTION 1*/}  
                      <View style={styles.predictionSection}>

                        {/* Spieler 1 */}
                        <View style={styles.predictionPlayerButton}>

                          <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                              currentPreditcionOne != 0 ?

                              <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionOne)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }
                                    
                          </View>

                          <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                            <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionOne == currentFinalPredictionOne && currentFinalPredictionOne != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionOne)}</Text>

                          </View>

                          <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                          {
                              currentPreditcionOne > 32 || currentRound != 128 ?

                              <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionOne, 0)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="caretright" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }

                          </View>

                        </View>

                        {/* Spieler 2 */}
                        <View style={styles.predictionPlayerButton}>

                          <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                              currentPreditcionTwo != 0 ?

                              <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionTwo)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }
                                    
                          </View>

                          <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                            <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionTwo == currentFinalPredictionOne && currentFinalPredictionOne != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionTwo)}</Text>

                          </View>

                          <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                              currentPreditcionTwo> 32 || currentRound != 128 ?

                              <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionTwo, 0)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="caretright" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }

                          </View>

                        </View>

                      </View>


                      {/* PREDICTION SECTION 2*/}  
                      <View style={styles.predictionSection}>

                        {/* Spieler 3 */}
                        <View style={styles.predictionPlayerButton}>

                          <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                          {
                              currentPreditcionThree != 0 ?

                              <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionThree)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }
                                    
                          </View>

                          <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                            <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionThree == currentFinalPredictionTwo && currentFinalPredictionTwo != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionThree)}</Text>

                          </View>

                          <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                          {
                              currentPreditcionThree> 32 || currentRound != 128 ?

                              <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionThree, 1)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="caretright" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }

                          </View>

                        </View>

                        {/* Spieler 4 */}
                        <View style={styles.predictionPlayerButton}>

                          <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                          {
                              currentPreditcionFour != 0 ?

                              <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionFour)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }
                                    
                          </View>

                          <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                            <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionFour == currentFinalPredictionTwo && currentFinalPredictionTwo != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionFour)}</Text>

                          </View>

                          <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                          {
                              currentPreditcionFour> 32 || currentRound != 128 ?

                              <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionFour, 1)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                <AntDesign name="caretright" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                              </TouchableOpacity>

                              :

                              <View/>
                            }

                          </View>

                        </View>

                      </View>

                      {/* FILLER */}  
                      <View style={{...styles.predictionSection, height: '30%'}}/>

                    </View>

                    {/* LINIE 2*/}
                    <View style={{height: '100%', width: '10%', justifyContent: 'center', flexDirection: 'row'}}>

                      <View style={{width: '50%', height: '100%'}}>

                        <View style={{...styles.predictionSection}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor, borderRightWidth: 5}}/>

                      </View>

                      <View style={{width: '50%', height: '100%'}}>

                        <View style={{...styles.predictionSection}}/>
                        <View style={{...styles.predictionSection, height: '10%'}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>

                      </View>

                    </View>

                  </View>

                  :
                
                  (
                    currentRound == 2 ?

                    <View style={{width: '95%', height: '75%', backgroundColor: frontColor, justifyContent: 'center', alignItems: 'center', borderRadius: 10, flexDirection: 'row'}}>

                      {/* LINIE 1*/}
                      <View style={{height: '100%', width: '10%'}}>

                        <View style={{...styles.predictionSection, height: '30%'}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: (currentRound == 128 ? 0 : 5), borderColor: backgroundColor}}/>

                      </View>

                      {/* TIPS */}
                      <View style={{height: '100%', width: '80%', justifyContent: 'center'}}>

                        {/* HEADLINE */}  
                        <View style={{...styles.predictionSection, height: '10%'}}>

                          {
                            <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 2)}}>{"Final"}</Text>
                          }

                        </View>

                        {/* FILLER */}  
                        <View style={{...styles.predictionSection, height: '30%'}}/>

                        {/* PREDICTION SECTION 1*/}  
                        <View style={styles.predictionSection}>

                          {/* Spieler 1 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                              {
                                currentPreditcionOne != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionOne)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionOne == currentFinalPredictionOne && currentFinalPredictionOne != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionOne)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionOne > 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionOne, 0)}} style={{width: '100%', height: '100%', backgroundColor: winnerYellowColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <FontAwesome5 name="crown" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                          {/* Spieler 2 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                              {
                                currentPreditcionTwo != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionTwo)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionTwo == currentFinalPredictionOne && currentFinalPredictionOne != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionTwo)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                              {
                                currentPreditcionTwo> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionTwo, 0)}} style={{width: '100%', height: '100%', backgroundColor: winnerYellowColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <FontAwesome5 name="crown" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                        </View>

                        {/* FILLER */}  
                        <View style={{...styles.predictionSection, height: '40%'}}/>

                      </View>

                      {/* LINIE 2*/}
                      <View style={{height: '100%', width: '10%', justifyContent: 'center', flexDirection: 'row'}}>

                        <View style={{width: '100%', height: '100%'}}>

                          <View style={{...styles.predictionSection}}/>
                          <View style={{...styles.predictionSection, height: '10%'}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>

                        </View>

                      </View>

                    </View>

                    :

                    <View style={{width: '95%', height: '75%', backgroundColor: frontColor, justifyContent: 'center', alignItems: 'center', borderRadius: 10, flexDirection: 'row'}}>

                      {/* LINIE 1*/}
                      <View style={{height: '100%', width: '8%'}}>

                        <View style={{...styles.predictionSection}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: (currentRound == 128 ? 0 : 5), borderColor: backgroundColor}}/>
                        <View style={{...styles.predictionSection, borderBottomWidth: (currentRound == 128 ? 0 : 5), borderColor: backgroundColor}}/>

                      </View>

                      {/* TIPS */}
                      <View style={{height: '100%', width: '84%', justifyContent: 'center'}}>

                        {/* HEADLINE */}  
                        <View style={{...styles.predictionSection, height: '10%'}}>

                          {
                            currentRound <= 8 ?

                            <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 2)}}>{"L"+currentRound}</Text>

                            :

                            <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 2)}}>{"L"+currentRound + " " + (roundStatus+1) + "/" + currentRound/8}</Text>
                          }

                        </View>

                        {/* PREDICTION SECTION 1*/}  
                        <View style={styles.predictionSection}>

                          {/* Spieler 1 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                              {
                                currentPreditcionOne != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionOne)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionOne == currentFinalPredictionOne && currentFinalPredictionOne != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionOne)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionOne > 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionOne, 0)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                          {/* Spieler 2 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                              {
                                currentPreditcionTwo != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionTwo)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionTwo == currentFinalPredictionOne && currentFinalPredictionOne != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionTwo)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                              {
                                currentPreditcionTwo> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionTwo, 0)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                        </View>


                        {/* PREDICTION SECTION 2*/}  
                        <View style={styles.predictionSection}>

                          {/* Spieler 3 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                                currentPreditcionThree != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionThree)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionThree == currentFinalPredictionTwo && currentFinalPredictionTwo != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionThree)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionThree> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionThree, 1)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                          {/* Spieler 4 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                                currentPreditcionFour != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionFour)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionFour == currentFinalPredictionTwo && currentFinalPredictionTwo != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionFour)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionFour> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionFour, 1)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                        </View>


                        {/* PREDICTION SECTION 3*/}  
                        <View style={styles.predictionSection}>

                          {/* Spieler 5 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                                currentPreditcionFive != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionFive)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionFive == currentFinalPredictionThree && currentFinalPredictionThree != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionFive)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionFive> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionFive, 2)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                          {/* Spieler 6 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                                currentPreditcionSix != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionSix)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionSix == currentFinalPredictionThree && currentFinalPredictionThree != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionSix)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionSix> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionSix, 2)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                        </View>


                        {/* PREDICTION SECTION 4*/}  
                        <View style={styles.predictionSection}>

                          {/* Spieler 7 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                                currentPreditcionSeven != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionSeven)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionSeven == currentFinalPredictionFour && currentFinalPredictionFour != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionSeven)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionSeven> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionSeven, 3)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                          {/* Spieler 8 */}
                          <View style={styles.predictionPlayerButton}>

                            <View style={{width: '8%', height: '100%', justifyContent: 'center'}}>

                            {
                                currentPreditcionEight != 0 ?

                                <TouchableOpacity onPress={() => {showParticipantInformationMobile(currentPreditcionEight)}} style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="questioncircleo" size={getUsableHeight("qmark") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }
                                      
                            </View>

                            <View style={{width: '76%', height: '100%', justifyContent: 'center'}}>

                              <Text style={{...styles.predictionPlayerText, fontSize: (getUsableHeight("ppText")- 4), fontWeight: ((currentPreditcionEight == currentFinalPredictionFour && currentFinalPredictionFour != 0) ? 'bold' : 'normal')}}>{getParticipantName(currentPreditcionEight)}</Text>

                            </View>

                            <View style={{width: '16%', height: '100%', justifyContent: 'center', padding: 5}}>

                            {
                                currentPreditcionEight> 32 || currentRound != 128 ?

                                <TouchableOpacity onPress={() => {handleParticipantBet(currentPreditcionEight, 3)}} style={{width: '100%', height: '100%', backgroundColor: lightGreenColor, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>
                                  <AntDesign name="caretright" size={getUsableHeight("arrow") - 2} color={fontButtonColor} />
                                </TouchableOpacity>

                                :

                                <View/>
                              }

                            </View>

                          </View>

                        </View>

                        {/* FILLER */}  
                        <View style={{...styles.predictionSection, height: '10%'}}/>

                      </View>

                      {/* LINIE 2*/}
                      <View style={{height: '100%', width: '8%', justifyContent: 'center', flexDirection: 'row'}}>

                        <View style={{width: '50%', height: '100%'}}>

                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor, borderRightWidth: 5}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor, borderRightWidth: 5}}/>

                        </View>

                        <View style={{width: '50%', height: '100%'}}>

                          <View style={{...styles.predictionSection, height: '10%'}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>
                          <View style={{...styles.predictionSection}}/>
                          <View style={{...styles.predictionSection, borderBottomWidth: 5, borderColor: backgroundColor}}/>

                        </View>

                      </View>

                    </View>
                  )

                }

                <View style={{width: '95%', height: '15%', justifyContent: 'space-evenly', alignItems: 'center'}}>

                  <View style={{width: '100%', height: '100%', justifyContent: 'space-evenly', alignItems: 'center', flexDirection: 'row'}}>

                    {
                      currentRound == 128 && roundStatus == 0 ?

                      <View style={{width: '45%', height: '70%', maxWidth: 150, maxHeight: 50}}/>

                      :

                      <TouchableOpacity onPress={() => goBack()} style={{width: '45%', height: '100%', backgroundColor: frontColor, maxWidth: 150, maxHeight: 50, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>

                      <Text style={{...styles.headlineText, fontSize: (getUsableHeight("hlText"))}}>Back</Text>

                      </TouchableOpacity>
                      
                    }

                    <TouchableOpacity onPress={() => goNext()} style={{width: '45%', height: '70%', backgroundColor: frontColor, maxWidth: 150, maxHeight: 50, borderRadius: 10, justifyContent: 'center', alignItems: 'center'}}>

                      <Text style={{...styles.headlineText, fontSize: (getUsableHeight("hlText"))}}>Next</Text>

                    </TouchableOpacity>

                  </View>
                  
                </View>



          </View>

        }


      </MobileView>

    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'gray',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: backgroundColor,
  },
  content: {
    width: '100%',
    height: '100%',
    maxHeight: 2000,
    maxWidth: 2000,
    backgroundColor: "backgroundColor",
    alignItems: 'center',
    justifyContent: 'center',
  },

  columnPlayers:
  {
    width: '12.5%',
    height: '100%',
    backgroundColor: 'transparent'
  },
  columnLine:
  {
    width: '2%',
    height: '100%',
    backgroundColor: 'transparent'
  },
  rowPlayers:
  {
    width: '100%',
    height: '3.125%',
    backgroundColor: 'transparent',
    justifyContent: 'space-around',
    alignContent: 'center',
    paddingVertical: '1%'
  },
  rowLine:
  {
    width: '100%',
    height: '3.125%',
    justifyContent: 'center',
    alignContent: 'center',
    borderBottomWidth: 1,
    borderColor: frontColor
  },

  playerButton:
  {
    width: '100%',
    height: '45%',
    backgroundColor: frontColor,
    borderRadius: 2,
    justifyContent: 'center',
    alignItems: 'left'
  },
  playerText:
  {
    paddingLeft: '5%',
    color: fontButtonColor,
    fontSize: 12,
  },
  headlineText:
  {
    fontWeight: 'bold',
    fontSize: 20,
    color: fontButtonColor,
  },

  predictionSection:
  {
    width: '100%',
    height: '20%',
    backgroundColor: 'transparent',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    paddingVertical: 10,
  },
  predictionPlayerButton:
  {
    width: '100%',
    height: '45%',
    backgroundColor: backgroundColor,
    borderRadius: 10,
    flexDirection: 'row'
  },
  predictionPlayerText:
  {
    fontWeight: 'bold',
    fontSize: 24,
    color: fontButtonColor,
  },
  playerInformationText:
  {
    color: fontButtonColor,
    fontSize: 17,
    textAlign: 'center'
  },
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.8)', // Transparenter Hintergrund
  },
  modalContent: {
    justifyContent: 'center', // Zentriere den Inhalt vertikal
    alignItems: 'center',    // Zentriere den Inhalt horizontal
    width: '100%',           // Nutze die gesamte Breite des Modals
    height: '100%',          // Nutze die gesamte Höhe des Modals
    position: 'relative',    // Erforderlich für das X-Icon (damit es absolut positioniert bleibt)
  },
  closeIcon: {
    position: 'absolute',
    top: 30, // Abstand von oben (je nach Design anpassen)
    right: 30, // Abstand von rechts
    backgroundColor: 'rgba(200, 200, 200, 0.8)', // Grauer Hintergrund für das Icon
    width: 40,
    height: 40,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10, // Sicherstellen, dass das Icon über dem Bild liegt
  },
  closeIconText: {
    color: 'black',
    fontSize: 20,
    fontWeight: 'bold',
  },
});
